import { billingNl } from "./billing.nl";
import { hrNl } from "./hr.nl";
import { dashboardNl } from "./dashboard.nl";
import { paymentsNl } from "./payments.nl";
import { reportsNl } from "./reports.nl";
import type { MessageId } from "./fr";

/** Dutch catalog. Same keys and {placeholders} as fr.ts (checked by catalogs.t.ts). */
// Terms: feature = functie (feature enablement = functie), role = rol, case (dossier) = dossier, pro = pro, client = klant, job request (demande) = aanvraag, lead (opportunité) = kans, report (signalement) = melding, reason (motif) = reden, reveal (afficher) = tonen, staff member = teamlid, sign out = afmelden, audit log = auditlogboek.
export const nl: Record<MessageId, string> = {
  ...reportsNl,
  ...paymentsNl,
  ...dashboardNl,
  ...billingNl,
  ...hrNl,
  // ── Brand and shell ──
  "brand.name": "Walliyo",
  "brand.initial": "W",
  "brand.console": "Console",
  "nav.aria": "Console",
  "nav.new": "NIEUW",
  "nav.group.configuration": "Configuratie",
  "overview.eachDepartment": "Elke afdeling, één regel",
  "overview.dept.marketplace": "Marktbeheer",
  "overview.dept.growth": "Verkoop & groei",
  "overview.dept.support": "Klantenservice",
  "overview.dept.trust": "Vertrouwen & veiligheid",
  "overview.dept.finance": "Financiën",
  "overview.dept.people": "Personeelszaken",
  "overview.dept.administration": "Administratie",
  "overview.dept.product": "Techniek",
  "overview.clickThrough": "klik door",
  "overview.numberToWatch": "Het getal om op te letten",
  "overview.whereWalliyoWorks": "Waar Walliyo werkt",
  "overview.noCitiesYet": "Deze maand geen klussen.",
  "overview.points": "{points} punten",
  "overview.title.people.walliyoMonth": "Walliyo, {month}",
  "overview.people.tab.waiting": "Wat u wacht",
  "overview.people.tab.company": "Het bedrijf",
  "overview.people.tab.weeks": "De komende weken",
  "overview.people.askForTimeOff": "Vrije dagen aanvragen",
  "overview.people.joinedThisMonth": "{count} deze maand erbij",
  "overview.people.joinedThisMonth.one": "1 deze maand erbij",
  "overview.people.candidates": "{count} kandidaten",
  "overview.people.candidates.one": "1 kandidaat",
  "overview.people.medianStay": "Jaar, mediane duur",
  "overview.people.whereEverybodyIs": "Waar iedereen is",
  "overview.people.oneLinePerTeam": "één regel per team",
  "overview.people.noTeamsYet": "Nog geen teams.",
  "overview.people.noLead": "geen leidinggevende",
  "overview.people.nobodyCovering": "Niemand vangt op",
  "overview.people.thinWeek": "{team} verliest {away} van {size} in de week van {week}.",
  "overview.people.whoIsWhere": "Wie waar is",
  "overview.people.fourWeeks": "vier weken, en wat er in elke valt",
  "overview.people.allTimeOff": "Alle vrije dagen",
  "overview.people.quietWeeks": "De komende vier weken valt er niets.",
  "overview.people.mark.payrollCloses": "loonrun sluit {on}",
  "overview.people.mark.reviewsClose": "beoordelingen sluiten {on}",
  "overview.people.span.leave": "{days} dagen vrij",
  "overview.people.span.leave.one": "1 dag vrij",
  "overview.people.span.leavePending": "{days} dagen · onbeslist",
  "overview.people.span.leavePending.one": "1 dag · onbeslist",
  "overview.people.span.starts": "begint",
  "overview.people.task.candidates": "{count} kandidaten wachten op u",
  "overview.people.detail.candidates": "voor {second} open functies",
  "marketplace.seeAll": "Alle {count} bekijken",
  "marketplace.findAPro": "Een pro vinden",
  "marketplace.theMarket": "De markt, deze week",
  "overview.title.marketplace.theMarket": "De markt, deze week",
  "overview.lede.marketplace.nobodyAnswered": "{first} mensen vroegen om iets en niemand antwoordde.",
  "overview.lede.marketplace.demandNoSupply": "{first} vakken worden gevraagd waar geen pro de vaardigheid heeft.",
  "overview.lede.marketplace.quiet": "Deze week is er niets geplaatst.",
  "overview.lede.marketplace.allAnswered": "Elke klus van deze week kreeg een prijsopgave.",
  "overview.people.link.employees": "Medewerkers",
  "overview.people.link.recruiting": "Recruitment",
  "overview.people.link.learning": "Opleiding",
  "overview.people.link.teams": "Teams",
  "overview.administration.askedNotAnswered": "Gevraagd, niet beantwoord",
  "overview.administration.oldestFirst": "het oudste eerst",
  "overview.administration.nobodyWaiting": "Niemand wacht op een antwoord.",
  "overview.administration.row.wantsUntil": "{subject} wil {asked}",
  "overview.administration.row.wantsForever": "{subject} wil {asked}, zonder einddatum",
  "overview.administration.until": "tot {on}",
  "overview.administration.noEndAsked": "geen einddatum gevraagd",
  "overview.administration.hoursWaiting": "{hours} uur wachtend",
  "overview.administration.hoursWaiting.one": "1 uur wachtend",
  "overview.administration.pastTheDeadline": "over de deadline",
  "overview.administration.nobodyTookItBack": "Niemand heeft het teruggenomen",
  "overview.administration.noEndDate": "{count} rechten hebben geen einddatum.",
  "overview.administration.noEndDate.one": "1 recht heeft geen einddatum.",
  "overview.administration.belongToLeavers": "{leavers} horen bij iemand die weg is.",
  "overview.administration.belongToLeavers.one": "1 hoort bij iemand die weg is.",
  "overview.administration.reviewThem": "Nakijken",
  "overview.administration.criticalCapabilities": "Kritieke bevoegdheden",
  "overview.administration.ifAnyReachesOne":
    "Als een ervan op één persoon uitkomt, kan niemand invallen als die er niet is.",
  "overview.figure.holdCritical": "Hebben iets kritieks",
  "overview.lede.administration.waitingAndGrants":
    "{first} mensen wachten op een antwoord, en {second} rechten hebben geen einddatum.",
  "overview.lede.administration.waiting": "{first} mensen wachten op een antwoord.",
  "overview.lede.administration.grants": "{first} rechten hebben geen einddatum en niemand heeft ze teruggenomen.",
  "overview.lede.administration.nothingWaiting": "Niemand wacht op een antwoord.",
  "overview.growth.step.signedUp": "Aangemeld",
  "overview.growth.step.verified": "Geverifieerd",
  "overview.growth.step.addedSkill": "Vak toegevoegd",
  "overview.growth.step.quotedOnce": "Eén keer geboden",
  "overview.growth.step.wonAJob": "Klus gewonnen",
  "overview.growth.lost.signedUp": "nooit aangemeld",
  "overview.growth.lost.verified": "gaven op",
  "overview.growth.lost.addedSkill": "deden het nooit",
  "overview.growth.lost.quotedOnce": "boden nooit",
  "overview.growth.lost.wonAJob": "wonnen nooit",
  "overview.growth.stuck": "Vastgelopen, en een telefoontje waard",
  "overview.growth.stuckWho": "geverifieerd, in een gevraagd vak, nooit geboden",
  "overview.growth.nobodyStuck": "Niemand zit vast.",
  "overview.growth.row.workGoingUnanswered": "{subject}",
  "overview.growth.why.workGoingUnanswered": "{days} dagen geleden geverifieerd · werk in hun vak blijft onbeantwoord",
  "overview.growth.row.neverQuoted": "{subject}",
  "overview.growth.why.neverQuoted": "{days} dagen geleden geverifieerd · heeft nooit geboden",
  "overview.growth.promoCost":
    "Ze heeft {given} aan korting weggegeven tegen {earned} aan kosten van de pro's die haar gebruikten.",
  "overview.growth.promoUsed": "{used} pro's hebben haar gebruikt",
  "overview.growth.beforeYouCampaign": "Voor u een campagne start",
  "overview.growth.notificationsAreFree":
    "Meldingen in de app bereiken deze pro's gratis. Sms kost per bericht, en data wordt hier per uur betaald.",
  "overview.action.call": "Bellen",
  "overview.lede.growth.neverQuoted":
    "{first} pro's hebben zich aangemeld en nooit op iets geboden. Dat is het hele werk.",
  "overview.lede.growth.nobodySignedUp": "Deze maand heeft niemand zich aangemeld.",
  "overview.lede.growth.allWorking": "Elke aangemelde pro heeft op iets geboden.",
  "overview.support.dueInMinutes.one": "deadline over 1 minuut",
  "overview.support.dueInHours.one": "deadline over 1 uur",
  "overview.support.overdue.one": "1 minuut over de deadline",
  "overview.support.nobodyOwnsWhy.one":
    "Een zaak zonder eigenaar is een zaak die niemand beantwoordt. De oudste ligt er al 1 dag.",
  "overview.people.days.one": "1 dag",
  "overview.people.payrollOpen.one": "{month} is open. Ze sluit morgen.",
  "overview.people.detail.leave.one": "1 dag geleden aangevraagd · u bent hun leidinggevende",
  "overview.finance.waiting.one": "1 dag wachtend",
  "overview.trust.row.appealWaiting.one": "Bezwaar wacht 1 dag",
  "overview.trust.legalHoldsWhy.one":
    "1 account is geblokkeerd. Niets daarover mag worden verwijderd, ook niet op dataverzoek.",
  "overview.product.unconfirmed.one": "1 callback onbevestigd, {minutes} minuten geleden.",
  "overview.product.whatIsBroken": "Wat kapot is",
  "overview.product.worstFirst": "het ergste eerst",
  "overview.product.nothingBroken": "Niets is kapot.",
  "overview.product.unconfirmed": "{count} callbacks onbevestigd, de oudste {minutes} minuten geleden.",
  "overview.product.unconfirmedWhy": "Elk is een pro die betaald heeft en niet als betaald staat.",
  "overview.product.replayThem": "Opnieuw afspelen",
  "overview.product.rolledOut": "Uitgerold bij klanten",
  "overview.product.tally.everybody": "Iedereen",
  "overview.product.tally.someAccounts": "Sommige accounts",
  "overview.product.tally.off": "Uit",
  "overview.figure.rolloutsInFlight": "Lopende uitrol",
  "overview.product.row.incidentOpen": "{subject}",
  "overview.product.why.incidentOpen": "{amount} open · klanten zien de banner",
  "overview.product.row.ruleScheduled": "Regel wordt {at} van kracht",
  "overview.product.why.ruleScheduled": "{subject} {amount} · niemand heeft afgetekend",
  "overview.product.row.experimentRunning": "{subject} bij {days}% van de klanten",
  "overview.product.why.experimentRunning": "loopt sinds {on} · klaar om over te beslissen",
  "overview.figure.incidentsOpen": "Open incidenten",
  "overview.lede.product.incidentAndCallbacks":
    "{first} incident is open, en {second} betalingscallbacks zijn mislukt.",
  "overview.lede.product.incident": "{first} incident is open.",
  "overview.lede.product.callbacks": "{first} betalingscallbacks zijn mislukt en niemand heeft ze opnieuw afgespeeld.",
  "overview.lede.product.rulesScheduled": "{first} regels worden van kracht zonder dat iemand erbij is.",
  "overview.lede.product.nothingBroken": "Niets is kapot.",
  "overview.finance.aboveLimit": "Boven iemands grens",
  "overview.finance.theyAskedYouDecide": "zij vroegen, u beslist",
  "overview.finance.nothingWaitingHere": "Er wacht geen goedkeuring.",
  "overview.finance.theirLimit": "grens {ceiling}",
  "overview.finance.noLimit": "heeft geen grens",
  "overview.finance.waiting": "{days} dagen wachtend",
  "overview.finance.today": "vandaag",
  "overview.finance.subscriptions": "Abonnementen",
  "overview.finance.tally.endingSoon": "Verlenging binnen 7 dagen",
  "overview.finance.tally.suspended": "Betaling mislukt",
  "overview.finance.tally.ended": "Beëindigd, niet verlengd",
  "overview.finance.promosRunning": "Lopende acties",
  "overview.finance.promoEnds": "{name} eindigt op {on}.",
  "overview.finance.promoNoEnd": "{name} heeft geen einddatum.",
  "overview.finance.promoCost": "Ze heeft {given} aan korting weggegeven tegen {earned} aan kosten.",
  "overview.figure.feesCollected": "Geïnde kosten",
  "overview.figure.jobsBilled": "Gefactureerde klussen",
  "overview.figure.renewalsFailed": "Mislukte verlengingen",
  "overview.lede.finance.waitingOnApproval": "{first} correcties wachten op iemand die ze kan goedkeuren.",
  "overview.lede.finance.renewalsFailed": "{first} verlengingen zijn mislukt en niemand heeft ze opgepakt.",
  "overview.lede.finance.renewingSoon": "{first} abonnementen verlengen deze week.",
  "overview.lede.finance.nothingWaiting": "Er wacht geen goedkeuring.",
  "overview.trust.needsDecision": "Vandaag te beslissen",
  "overview.trust.mostSeriousFirst": "het ernstigste eerst",
  "overview.trust.nothingUrgentHere": "Vandaag is er niets te beslissen.",
  "overview.trust.verificationQueue": "Verificatiewachtrij",
  "overview.trust.whyVerify": "Een pro die op verificatie wacht, is niet te vinden en niet in te huren.",
  "overview.trust.tally.underADay": "Wacht minder dan 24 u",
  "overview.trust.tally.overADay": "Meer dan 24 u",
  "overview.trust.legalHolds": "Juridische blokkades",
  "overview.trust.legalHoldsWhy":
    "{count} accounts zijn geblokkeerd. Niets daarover mag worden verwijderd, ook niet op dataverzoek.",
  "overview.trust.row.criticalUnreferred": "{subject}",
  "overview.trust.why.criticalUnreferred": "kritiek · niet doorgegeven aan de politie",
  "overview.trust.row.restrictionExpiring": "De maatregel loopt op {on} zelf af",
  "overview.trust.why.restrictionExpiring": "{subject} · hef hem op, of hij heft zichzelf op",
  "overview.trust.row.appealWaiting": "Bezwaar wacht {days} dagen",
  "overview.trust.why.appealWaiting": "een beperkt account vroeg om herziening",
  "overview.figure.underLegalHold": "Juridisch geblokkeerd",
  "overview.lede.trust.criticalUnreferred": "{first} meldingen zijn kritiek en geen enkele is doorgegeven.",
  "overview.lede.trust.waitingOverADay": "{first} pro's wachten al meer dan een dag op verificatie.",
  "overview.lede.trust.waitingToVerify": "{first} pro's wachten op verificatie.",
  "overview.lede.trust.nothingUrgent": "Vandaag is er niets te beslissen.",
  "overview.support.runningOut": "De tijd dringt",
  "overview.support.soonestFirst": "dichtstbijzijnde deadline eerst",
  "overview.support.nothingDue": "Geen deadline is nabij.",
  "overview.support.whereFrom": "Waar ze vandaan kwamen",
  "overview.support.noChannels": "Geen open zaken.",
  "overview.support.channel.chat": "In de app",
  "overview.support.channel.phone": "Telefoon",
  "overview.support.channel.email": "E-mail",
  "overview.support.nobodyOwns": "{count} zonder eigenaar",
  "overview.support.nobodyOwnsWhy":
    "Een zaak zonder eigenaar is een zaak die niemand beantwoordt. De oudste ligt er al {days} dagen.",
  "overview.support.takeOldest": "Neem de oudste",
  "overview.support.row.mine": "van u",
  "overview.support.row.theirs": "van iemand anders",
  "overview.support.row.unclaimed": "zonder eigenaar",
  "overview.support.dueInMinutes": "deadline over {minutes} minuten",
  "overview.support.dueInHours": "deadline over {hours} uur",
  "overview.support.overdue": "{minutes} minuten over de deadline",
  "overview.figure.toFirstReply": "Tot eerste antwoord",
  "overview.action.reply": "Antwoorden",
  "overview.action.claim": "Overnemen",
  "overview.lede.support.breaching": "{first} zaken gaan hun deadline missen.",
  "overview.lede.support.breachingSomeYours": "{first} zaken gaan hun deadline missen. {second} daarvan zijn van u.",
  "overview.lede.support.unclaimed": "{first} zaken wachten tot iemand ze oppakt.",
  "overview.lede.support.nothingBreaching": "Geen zaak gaat zijn deadline missen.",
  "overview.against": "tegen {month}",
  "overview.title.executive.walliyoMonth": "Walliyo, {month}",
  "overview.title.people.thingsNeedYou": "{count} dingen hebben u nodig",
  "overview.title.people.nothingNeedsYou": "Niets heeft u nodig",
  "overview.title.support.bonjour": "Hallo, {name}",
  "overview.title.trust.safetyToday": "Veiligheid, vandaag",
  "overview.title.finance.theMoney": "Het geld, deze week",
  "overview.title.product.themOrUs": "Ligt het aan hen of aan ons",
  "overview.title.growth.gettingProsWorking": "Pro's aan het werk krijgen",
  "overview.title.administration.whoMayDoWhat": "Wie mag wat",
  "overview.title.marketplace.plain": "Overzicht",
  "overview.title.legal.plain": "Overzicht",
  "overview.lede.executive.grewFaster": "De markt groeide. Wat zij niet kon bedienen, groeide sneller.",
  "overview.lede.executive.wentUnanswered": "{first} aanvragen bleven deze maand onbeantwoord.",
  "overview.lede.executive.quiet": "Deze maand is er niets geplaatst.",
  "overview.lede.executive.holding": "{second} aanvragen geplaatst, en elk daarvan kreeg een antwoord.",
  "overview.people.allClear": "Niets heeft u nodig. Alles is afgehandeld.",
  "overview.people.theCompany": "Het bedrijf",
  "overview.people.employees": "medewerkers",
  "overview.people.teams": "teams",
  "overview.people.yours": "Van u",
  "overview.people.leaveLeft": "Resterende vrije dagen",
  "overview.people.days": "{days} dagen",
  "overview.people.noAllowance": "niet ingesteld",
  "overview.people.coursesDue": "Cursussen te doen",
  "overview.people.payroll": "Loonrun",
  "overview.people.payrollOpen": "{month} is open. Ze sluit over {days} dagen.",
  "overview.people.payrollDue": "{month} is open en de sluitingsdatum is verstreken.",
  "overview.people.payrollClosed": "{month} is gesloten.",
  "overview.people.linesChecked": "{checked} van {total} regels gecontroleerd",
  "overview.people.task.leave": "{subject} vraagt {count} dagen vrij",
  "overview.people.detail.leave": "{days} dagen geleden aangevraagd · u bent hun leidinggevende",
  "overview.people.task.grantsNoEndDate": "{count} rechten hebben geen einddatum",
  "overview.people.detail.grantsNoEndDate": "{second} horen bij mensen die u leidt",
  "overview.people.task.reviews": "{count} beoordelingen moet u schrijven",
  "overview.people.detail.reviews": "sluit op {on}",
  "overview.people.task.starting": "{subject} begint op {on}",
  "overview.people.detail.starting": "rol al toegewezen",
  "overview.people.task.startingNoRole": "{subject} begint op {on}",
  "overview.people.detail.startingNoRole": "nog geen rol toegewezen",
  "overview.action.decide": "Beslissen",
  "overview.action.review": "Nakijken",
  "overview.action.write": "Schrijven",
  "overview.action.setUp": "Inrichten",
  "overview.action.open": "Openen",
  "overview.hero.jobsPosted": "Klussen geplaatst",
  "overview.hero.gotAQuote": "Met offerte",
  "overview.hero.fees": "Kosten, GNF",
  "overview.hero.activePros": "Actieve vakmensen",
  "overview.hero.employees": "Medewerkers",
  "overview.headline.unanswered": "{count} klussen zonder bod · {second} vakgebieden onbedekt",
  "overview.headline.neverQuoted": "{count} vakmensen aangemeld en nooit geboden",
  "overview.headline.breaching": "{count} dossiers bijna te laat · {second} zonder eigenaar",
  "overview.headline.criticalUnreferred":
    "{count} kritieke meldingen niet doorgegeven · {second} verificaties in wachtrij",
  "overview.headline.approvalsWaiting": "{count} correcties wachten · {second} te laat",
  "overview.headline.approvalsWaiting.zero": "{count} correcties wachten · niets te laat",
  "overview.headline.grantsWithoutExpiry": "{count} rechten zonder einddatum · {second} toegangsverzoeken",
  "overview.headline.incidentsOpen": "{count} incident open · {second} callbacks mislukt",
  "overview.headline.startingAndPayroll": "{count} nieuwe medewerkers · loonrun open",
  "overview.watch.demandOutrunningSupply":
    "Klussen stijgen {first}% en het aandeel met een prijsopgave daalt {second} punten. De vraag komt sneller dan het aanbod kan antwoorden.",
  "overview.watch.nobodyAnswered": "{first} klussen zijn geplaatst waarop niemand heeft geboden.",
  "roles.new.department": "Afdeling",
  "roles.new.pickDepartment": "Kies een afdeling…",
  "roles.new.departmentNeeded":
    "Kies de afdeling van de rol: een QA-tester hoort bij Product en techniek, een boekhouder bij Financiën.",
  "screen.experiments": "Experimenten",
  "screen.leads": "Prospects",
  "screen.campaigns": "Campagnes",
  "screen.referrals": "Verwijzingen",
  "experiments.title": "Experimenten",
  "experiments.sub": "Een functie aanzetten voor een deel van de klanten en vergelijken.",
  "experiments.loadFailed": "Experimenten konden niet worden geladen.",
  "experiments.none": "Geen experiment.",
  "experiments.start": "Experiment starten",
  "experiments.created": "{reference} aangemaakt",
  "experiments.moved": "{reference} op {percent}%",
  "experiments.ship": "Uitrollen",
  "experiments.stop": "Stoppen",
  "experiments.sticky": "Iemand blijft in zijn groep: de groep wordt berekend, nooit geloot.",
  "experiments.col.name": "Experiment",
  "experiments.col.feature": "Functie",
  "experiments.col.share": "Aandeel",
  "experiments.col.status": "Status",
  "experiments.col.ramp": "Uitbreiden",
  "experiments.status.draft": "Concept",
  "experiments.status.running": "Loopt",
  "experiments.status.stopped": "Gestopt",
  "experiments.status.shipped": "Uitgerold",
  "experiments.startTitle": "Experiment starten",
  "experiments.startBody": "Het begint op 0%: aanmaken en openen zijn twee besluiten.",
  "experiments.startSubmit": "Aanmaken",
  "experiments.featureNeeded": "Kies een klantfunctie.",
  "experiments.pickFeature": "Kiezen…",
  "experiments.field.name": "Wat geprobeerd wordt",
  "experiments.field.feature": "Klantfunctie",
  "experiments.field.featureHint": "Een experiment loopt op klanten, nooit op medewerkers.",
  "experiments.field.metric": "Wat gemeten wordt",
  "experiments.field.metricHint": "Door een mens gelezen, niet door code.",
  "leads.title": "Prospects",
  "leads.sub": "Vakmensen die we willen en nog niet hebben.",
  "leads.loadFailed": "Prospects konden niet worden geladen.",
  "leads.none": "Geen prospect.",
  "leads.add": "Prospect toevoegen",
  "leads.added": "{name} toegevoegd",
  "leads.moved": "{name} bijgewerkt",
  "leads.markContacted": "Benaderd",
  "leads.markLost": "Verloren",
  "leads.nameNeeded": "Geef de naam van de vakman.",
  "leads.status.new": "Nieuw",
  "leads.status.contacted": "Benaderd",
  "leads.status.signed_up": "Aangemeld",
  "leads.status.lost": "Verloren",
  "leads.source.coverage_gap": "Dekkingsgat",
  "leads.source.referral": "Aanbeveling",
  "leads.source.inbound": "Inkomend",
  "leads.source.other": "Anders",
  "leads.addTitle": "Prospect toevoegen",
  "leads.addBody": "Iemand die nog niet op het platform staat.",
  "leads.addSubmit": "Toevoegen",
  "leads.field.name": "Naam",
  "leads.field.phone": "Telefoon",
  "leads.field.trade": "Vakgebied",
  "leads.field.city": "Stad",
  "leads.field.source": "Herkomst",
  "campaigns.title": "Campagnes",
  "campaigns.sub": "Berichten aan vakmensen en klanten.",
  "campaigns.loadFailed": "Campagnes konden niet worden geladen.",
  "campaigns.none": "Geen campagne.",
  "campaigns.draft": "Campagne opstellen",
  "campaigns.drafted": "{reference} klaar: {count} ontvangers",
  "campaigns.send": "Versturen",
  "campaigns.sent": "Naar {count} personen verstuurd",
  "campaigns.wentTo": "Ging naar {count}",
  "campaigns.budgetNeeded": "Een sms-campagne heeft een budget nodig.",
  "campaigns.onlyInactive": "Alleen wie niets heeft gedaan",
  "campaigns.inAppFree": "Gratis: de melding komt in de app aan.",
  "campaigns.smsCosts": "Betaald: elke sms kost geld, en data wordt hier per uur betaald.",
  "campaigns.smsLength": "{count} tekens (boven 160 zijn het twee sms'jes per persoon)",
  "campaigns.channel.in_app": "In de app",
  "campaigns.channel.sms": "Sms",
  "campaigns.audience.pros": "Vakmensen",
  "campaigns.audience.customers": "Klanten",
  "campaigns.draftTitle": "Campagne opstellen",
  "campaigns.draftBody": "Het aantal ontvangers wordt bij het versturen opnieuw geteld.",
  "campaigns.draftSubmit": "Opstellen",
  "campaigns.field.name": "Naam",
  "campaigns.field.channel": "Kanaal",
  "campaigns.field.audience": "Ontvangers",
  "campaigns.field.body": "Bericht",
  "campaigns.field.bodyHint": "In het Frans, zichtbaar voor iedereen.",
  "campaigns.field.budget": "Budget (GNF)",
  "campaigns.field.budgetHint": "Wat uitgegeven mag worden.",
  "referrals.title": "Verwijzingen",
  "referrals.sub": "Vakmensen gebracht door andere vakmensen.",
  "referrals.loadFailed": "Verwijzingen konden niet worden geladen.",
  "referrals.none": "Geen verwijzing.",
  "referrals.unused": "Code ongebruikt",
  "referrals.paidOut": "{amount} {currency} uitbetaald",
  "referrals.paidWhen": "Betaald wanneer de aangebrachte vakman zijn eerste klus wint.",
  "referrals.status.open": "Open",
  "referrals.status.signed_up": "Aangemeld",
  "referrals.status.rewarded": "Uitbetaald",
  "referrals.status.expired": "Verlopen",
  "screen.incidents": "Storingen",
  "incidents.title": "Storingen",
  "incidents.sub": "Wat kapot is, en wat mensen te horen krijgen.",
  "incidents.loadFailed": "Storingen konden niet worden geladen.",
  "incidents.openOne": "Storing openen",
  "incidents.happeningNow": "Nu aan de gang",
  "incidents.allWell": "Alles werkt.",
  "incidents.over": "Afgelopen",
  "incidents.open": "Openen",
  "incidents.notAnnounced": "Niet aangekondigd",
  "incidents.started": "Begonnen op {when}",
  "incidents.opened": "{reference} geopend",
  "incidents.updated": "{reference} bijgewerkt",
  "incidents.status.open": "Open",
  "incidents.status.monitoring": "Onder toezicht",
  "incidents.status.resolved": "Opgelost",
  "incidents.severity.degraded": "Verminderd",
  "incidents.severity.down": "Uit de lucht",
  "incidents.openTitle": "Storing openen",
  "incidents.openBody":
    "Zolang deze open staat ziet elke klant een banner. Laat leeg om de storing te volgen zonder iets aan te kondigen.",
  "incidents.openSubmit": "Openen",
  "incidents.titleNeeded": "Zeg in een paar woorden wat kapot is.",
  "incidents.causeNeeded": "Zeg waarom het gebeurde voordat u afsluit.",
  "incidents.updateSubmit": "Opslaan",
  "incidents.field.title": "Wat kapot is",
  "incidents.field.severity": "Ernst",
  "incidents.field.banner": "Bericht aan klanten",
  "incidents.field.bannerHint": "In het Frans, zichtbaar voor iedereen. Leeg: niemand wordt ingelicht.",
  "incidents.field.status": "Status",
  "incidents.field.note": "Notitie",
  "incidents.field.noteHint": "Komt in het logboek, dat niets kan herschrijven.",
  "incidents.field.cause": "Oorzaak",
  "screen.overview": "Overzicht",
  "overview.sub": "Wat vandaag op u wacht.",
  "overview.loadFailed": "Het overzicht kon niet worden geladen.",
  "overview.needsYou": "Wat u nodig heeft",
  "overview.nothingToShow": "Niets te tonen: u heeft niets van wat deze afdeling leest.",
  "overview.waitingDays": "{days} d wachten",
  "overview.figure.leaveToDecide": "Verlof te beslissen",
  "overview.figure.reviewsOwed": "Beoordelingen te schrijven",
  "overview.figure.openRoles": "Open functies",
  "overview.figure.startingSoon": "Deze week begonnen",
  "overview.figure.payrollOpen": "Open loonruns",
  "overview.figure.leaversStillHolding": "Vertrokkenen met toegang",
  "overview.figure.accessRequests": "Toegangsverzoeken",
  "overview.figure.grantsWithoutExpiry": "Rechten zonder einddatum",
  "overview.figure.rolesHeldByNobody": "Rollen zonder houder",
  "overview.figure.staffWithSignIn": "Actieve medewerkers",
  "overview.figure.casesBreaching": "Dossiers bijna te laat",
  "overview.figure.casesMine": "Uw dossiers",
  "overview.figure.casesUnclaimed": "Dossiers zonder eigenaar",
  "overview.figure.casesOpen": "Open dossiers",
  "overview.figure.criticalUnreferred": "Kritieke meldingen niet doorgegeven",
  "overview.figure.verificationsWaiting": "Verificaties in wachtrij",
  "overview.figure.verificationsOverADay": "Langer dan 24 u",
  "overview.figure.reportsOpen": "Open meldingen",
  "overview.figure.restrictionsToReview": "Maatregelen te herzien",
  "overview.figure.legalHolds": "Juridische bewaringen",
  "overview.figure.approvalsWaiting": "Correcties goed te keuren",
  "overview.figure.feesThisMonth": "Betalingen deze maand",
  "overview.figure.creditsOutstanding": "Uitstaande kredieten",
  "overview.figure.subscriptionsEndingSoon": "Abonnementen eindigen binnen 7 d",
  "overview.figure.providerEventsFailed": "Mislukte terugmeldingen",
  "overview.figure.rulesScheduled": "Geplande regels",
  "overview.figure.featureExceptions": "Functie-uitzonderingen",
  "overview.figure.prosSignedUp": "Vakmensen aangemeld (30 d)",
  "overview.figure.prosApproved": "Vakmensen goedgekeurd (30 d)",
  "overview.figure.prosNeverQuoted": "Vakmensen die nooit boden",
  "overview.figure.prosWithWork": "Vakmensen met werk",
  "overview.figure.promosRunning": "Lopende acties",
  "overview.figure.jobsThisMonth": "Klussen deze maand",
  "overview.figure.customers": "Klantaccounts",
  "overview.item.caseDueOwned": "Uw dossier loopt af",
  "overview.item.caseDueUnclaimed": "Dossier zonder eigenaar loopt af",
  "screen.marketplaceOverview": "Overzicht",
  "screen.jobs": "Klussen",
  "screen.providers": "Vakmensen",
  "screen.categories": "Vakgebieden",
  "screen.marketplaceReviews": "Beoordelingen",
  "marketplace.title": "De markt",
  "marketplace.sub": "Wat gevraagd is, wie het kan, en waar niemand het kan.",
  "marketplace.loadFailed": "De markt kon niet worden geladen.",
  "marketplace.posted": "Klussen geplaatst",
  "marketplace.gotQuote": "Met offerte",
  "marketplace.accepted": "Geaccepteerd",
  "marketplace.noBids": "Niemand bood",
  "marketplace.toFirstQuote": "Tot 1e offerte",
  "marketplace.hoursShort": "{hours} u",
  "marketplace.nobodyBid": "Hierop bood niemand",
  "marketplace.nobodyBidHint": "Oudste eerst.",
  "marketplace.allAnswered": "Alles wat geplaatst is heeft antwoord gehad.",
  "marketplace.waitingDays": "{days} d wachten",
  "marketplace.noProHere": "hier kan niemand dit",
  "marketplace.prosNearby": "{count} vakmensen in de buurt",
  "marketplace.demandNoSupply": "Vraag zonder aanbod",
  "marketplace.demandNoSupplyHint": "Afgelopen 30 dagen gevraagd, zonder vakman ter plaatse.",
  "marketplace.everywhereCovered": "Elke stad heeft vakmensen voor wat er gevraagd wordt.",
  "marketplace.activePros": "{count} vakmensen kunnen vandaag werken",
  "marketplace.jobs": "Klussen",
  "marketplace.jobsSub": "Elke klus, en hoe ver die kwam.",
  "marketplace.noJobs": "Geen klus komt overeen.",
  "marketplace.filter.all": "Alle",
  "marketplace.filter.no_quotes": "Zonder offerte",
  "marketplace.filter.requested": "Geplaatst",
  "marketplace.filter.quoted": "Met offerte",
  "marketplace.filter.accepted": "Geaccepteerd",
  "marketplace.filter.cancelled": "Geannuleerd",
  "marketplace.status.requested": "Geplaatst",
  "marketplace.status.quoted": "Met offerte",
  "marketplace.status.accepted": "Geaccepteerd",
  "marketplace.status.cancelled": "Geannuleerd",
  "marketplace.status.declined": "Geweigerd",
  "marketplace.status.expired": "Verlopen",
  "marketplace.col.job": "Klus",
  "marketplace.col.city": "Stad",
  "marketplace.col.posted": "Geplaatst",
  "marketplace.col.quotes": "Offertes",
  "marketplace.col.estimate": "Schatting",
  "marketplace.col.status": "Status",
  "marketplace.providers": "Vakmensen",
  "marketplace.providersSub": "Wie kan werken, en wie nog niet werkt.",
  "marketplace.noPros": "Geen vakman komt overeen.",
  "marketplace.neverQuoted": "Nooit geboden",
  "marketplace.allPros": "Iedereen",
  "marketplace.unverified": "Niet geverifieerd",
  "marketplace.col.pro": "Vakman",
  "marketplace.col.skills": "Vakgebieden",
  "marketplace.col.quotesGiven": "Offertes gegeven",
  "marketplace.col.rating": "Beoordeling",
  "marketplace.categories": "Vakgebieden",
  "marketplace.categoriesSub": "Wat mensen vragen, en of iemand het kan.",
  "marketplace.noCategories": "Geen vakgebied te tonen.",
  "marketplace.noDemand": "Geen vraag",
  "marketplace.coverageHint": "Dekking is het aandeel klussen met minstens één offerte.",
  "marketplace.col.category": "Vakgebied",
  "marketplace.col.jobs": "Klussen",
  "marketplace.col.pros": "Vakmensen",
  "marketplace.col.coverage": "Dekking",
  "marketplace.col.uncovered": "Steden zonder vakman",
  "marketplace.reviews": "Beoordelingen",
  "marketplace.reviewsSub": "Wat klanten over vakmensen zeggen.",
  "marketplace.noReviews": "Geen beoordeling komt overeen.",
  "marketplace.poorOnly": "3 sterren of minder",
  "marketplace.allReviews": "Alle",
  "marketplace.averageIs": "Gemiddeld {average} over {total} beoordelingen",
  "nav.group.everyone": "Iedereen",
  "workspace.yours": "Uw werkruimtes",
  "department.executive": "Directie",
  "department.executive.blurb": "Het bedrijf in één oogopslag",
  "department.marketplace": "Marktbeheer",
  "department.marketplace.blurb": "Klussen, vakmensen, categorieën",
  "department.support": "Klantenservice",
  "department.support.blurb": "Dossiers, klanten en vakmensen",
  "department.trust": "Vertrouwen en veiligheid",
  "department.trust.blurb": "Verificaties, meldingen, maatregelen",
  "department.finance": "Financiën",
  "department.finance.blurb": "Kosten, correcties, abonnementen",
  "department.growth": "Verkoop en groei",
  "department.growth.blurb": "Vakmensen werven, acties",
  "department.product": "Product en techniek",
  "department.product.blurb": "Storingen, regels, uitrol",
  "department.people": "Personeelszaken",
  "department.people.blurb": "Werving, dienstverband, loon",
  "department.administration": "Beheer en beveiliging",
  "department.administration.blurb": "Rollen, rechten, logboek",
  "department.legal": "Juridisch en compliance",
  "department.legal.blurb": "Voorwaarden, gegevens, verzoeken",
  "nav.signedInAs": "Aangemeld als",
  "nav.screenCount": "{roles} · {visible} van {total} schermen",
  "profile.title": "Je profiel",
  "profile.open": "Profiel openen",
  "profile.identity": "Jij",
  "profile.email": "E-mail",
  "profile.roles": "Rollen",
  "profile.permits": "Wat je rollen toestaan",
  "profile.screensOpen": "{visible} van {total} schermen open",
  "profile.actionCount": "{count} acties beschikbaar",
  "profile.noPermissions": "Geen bevoegdheid met limiet: niets vereist goedkeuring.",
  "profile.preferences": "Voorkeuren",
  "profile.emailLabel": "E-mail:",
  "profile.uuidLabel": "UUID:",
  "profile.rolesLabel": "Rollen",
  "profile.figure.screens": "schermen die voor u openstaan",
  "profile.figure.actions": "acties die u kunt doen",
  "profile.figure.ceilings": "met een plafond",
  "profile.ceilingHeading": "Het meeste dat u alleen mag doen",
  "profile.ceilingHint": "Boven een plafond opent de actie nog steeds — uw poging wordt een goedkeuringsverzoek.",
  "profile.signOutHint": "Je moet opnieuw inloggen.",
  "header.signOut": "Afmelden",
  "header.signingOut": "Afmelden…",
  "header.language": "Taal van de console",
  "header.theme": "Thema",
  "header.theme.system": "Systeem",
  "header.theme.light": "Licht",
  "header.theme.dark": "Donker",
  "header.languageNotSaved": "Alleen voor deze sessie: deze keuze wordt nog niet in uw account opgeslagen.",
  "shell.loading": "Console laden…",
  "shell.loadFailed": "Uw profiel kon niet worden geladen",
  "shell.retry": "Opnieuw proberen",
  "shell.refreshFailed":
    "Uw rechten konden niet worden vernieuwd. De console toont de rechten die om {time} zijn geladen.",
  "shell.noScreens": "Er is geen scherm open voor uw rollen ({roles}). Vraag een leidinggevende om toegang.",
  "shell.noRoles": "Er is nog geen scherm voor u toegankelijk. Vraag een leidinggevende om een rol.",
  "connection.retrying": "Onstabiele verbinding · nieuwe poging {attempt} van {max}…",

  // ── Screens ──
  "screen.dashboard": "Dashboard",
  "screen.myRequests": "Mijn aanvragen",
  "screen.myTimeOff": "Mijn vrije dagen",
  "myTimeOff.sub": "Uw saldo, wat u hebt aangevraagd, en wie er nog weg is.",
  "myRequests.sub": "Waar u om hebt gevraagd, en hoe het met elk antwoord staat.",
  "screen.as.directory": "Directory",
  "screen.as.market": "Markt",
  "screen.as.employees": "Medewerkers",
  "screen.as.recruiting": "Recruitment",
  "screen.as.learning": "Opleiding",
  "screen.as.payroll": "Loonrun",
  "screen.as.money": "Geld",
  "screen.as.workforce": "Personeel",
  "screen.as.accounts": "Accounts",
  "screen.cases": "Dossiers",
  "screen.customers": "Klanten & pro's",
  "screen.verifications": "Verificaties",
  "screen.reports": "Meldingen",
  "screen.billing": "Prijzen en abonnementen",
  "screen.payments": "Betalingen",
  "screen.features": "Functieactiveringen",
  "screen.userSettings": "Gebruikersinstellingen",
  "settings.title": "Gebruikersinstellingen",
  "settings.tab.app": "App-gebruiker",
  "settings.tab.employee": "Medewerker",
  "settings.col.setting": "Instellingen",
  "settings.default": "Standaardwaarde",
  "settings.setHere": "Voor deze persoon ingesteld",
  "settings.clear": "Wissen",
  "settings.none": "Geen instelling past.",
  "screen.actions": "Acties",
  "actions.title": "Acties",
  "actions.col.action": "Actie",
  "actions.effect.read": "Lezen",
  "actions.effect.write": "Schrijven",
  "actions.alsoGates": "+{count} andere",
  "actions.col.area": "Gebied",
  "actions.col.effect": "Effect",
  "actions.col.audited": "Geaudit",
  "actions.col.needs": "Vereist",
  "actions.needs.nothing": "Niets",
  "actions.yes": "Ja",
  "actions.no": "Nee",
  "actions.surface.system": "Systeem",
  "actions.search": "Actie zoeken",
  "actions.none": "Geen actie past.",
  "screen.permissions": "Rechten",
  "permissions.title": "Rechten",
  "permissions.tab.role": "Rol",
  "permissions.tab.employee": "Medewerker",
  "permissions.col.limit": "Limiet",
  "permissions.col.expires": "Verloopt",
  "permissions.source.staffRole": "Via rol",
  "permissions.source.staffMember": "Uitzondering",
  "permissions.source.allStaff": "Alle medewerkers",
  "permissions.source.default": "Geen",
  "permissions.noLimit": "Geen plafond",
  "permissions.featureOff": "Functie staat uit",
  "permissions.approvable": "Kan vragen",
  "permissions.pickRole": "Kies een rol",
  "audit.kind.featureEnablements": "Functieactiveringen",
  "audit.kind.permissions": "Rechten",
  "audit.kind.teams": "Rollen en teams",
  "audit.kind.actions": "Acties",
  "audit.kind.userSettings": "Gebruikersinstellingen",
  "screen.roles": "Rollen",
  "roles.title": "Rollen",
  "roles.grants.none": "Verleent nog niets",
  "roles.grants.permissions": "Permissies wijzigen",
  "roles.grants.features": "Functies wijzigen",
  "roles.explain":
    "Wat iemand geleerd heeft en mag doen. Een rol is in elk team dezelfde — leidinggeven is er dus geen, dat stel je in bij Teams.",
  "roles.col.name": "Rol",
  "roles.col.description": "Waar het over gaat",
  "roles.col.members": "Personen",
  "roles.none": "Nog geen rollen.",
  "roles.loading": "Rollen laden…",
  "roles.loadFailed": "De rollen konden niet worden gelezen.",
  "roles.retry": "Opnieuw proberen",
  "roles.edit": "Hernoemen",
  "roles.save": "Opslaan",
  "roles.cancel": "Annuleren",
  "roles.created": "Rol aangemaakt.",
  "roles.new": "Nieuwe rol",
  "roles.new.title": "Nieuwe rol",
  "roles.back": "← Alle rollen",
  "roles.opens": "Wat het opent",
  "roles.opens.explain":
    "De schermen die deze rol kan bereiken, uit de vinkjes links. Geen aparte lijst — een scherm verschijnt omdat de rol heeft wat nodig is, en de API controleert hetzelfde.",
  "roles.new.name": "Naam",
  "roles.new.description": "Waar het over gaat",
  "roles.new.create": "Rol aanmaken",
  "roles.new.nameNeeded": "Geef de rol een naam.",
  "roles.new.grantsNeeded": "Kies waar de rol voor is: een rol die niets verleent heeft geen effect.",
  "roles.new.grants": "Wat het kan gebruiken",
  "roles.new.permissions": "Wat het mag doen",
  "roles.lock.critical": "Alleen een Owner kan dit verlenen.",
  "roles.lock.high": "U kunt alleen verlenen wat u zelf heeft.",
  "roles.lock.readOnly": "U kunt niets verlenen op een rol.",
  "roles.lock.featureFirst": "Zet eerst aan waar dit op rust.",
  "screen.teams": "Teams",
  "teams.title": "Teams",
  "teams.col.name": "Team",
  "teams.col.purpose": "Waarvoor het is",
  "teams.col.lead": "Geleid door",
  "teams.col.members": "Personen",
  "teams.col.status": "Status",
  "teams.col.person": "Persoon",
  "teams.col.roles": "Rol",
  "teams.col.onTeam": "In het team",
  "teams.col.leads": "Leidt het",
  "teams.open": "Openen",
  "teams.back": "Alle teams",
  "teams.none": "Nog geen teams.",
  "teams.noMembers": "Nog niemand in dit team.",
  "teams.noOthers": "Iedereen zit al in dit team.",
  "teams.loading": "Teams laden…",
  "teams.loadFailed": "De teams konden niet worden gelezen.",
  "teams.retry": "Opnieuw proberen",
  "teams.status.open": "Open",
  "teams.status.closed": "Gesloten",
  "teams.rename": "Hernoemen",
  "teams.close": "Team sluiten",
  "teams.reopen": "Weer openen",
  "teams.closedReason": "Gesloten",
  "teams.reopenedReason": "Heropend",
  "teams.closedNote": "Gesloten. Iedereen blijft erin: bij heropenen staan ze er nog.",
  "teams.new": "Nieuw team",
  "teams.explain":
    "Een groep mensen die hetzelfde werk doen, met een leiding. Werk gaat naar het team, niet naar een persoon: wie vandaag dienst heeft pakt de volgende. Een team verleent niets.",
  "teams.new.people":
    "Wie er vanaf het begin in zit. Vink “Leidt het” aan om te zeggen wiens mensen dit zijn: zij verdelen het werk van het team opnieuw en vallen voor iedereen in.",
  "teams.new.name": "Naam",
  "teams.new.purpose": "Waarvoor het is",
  "teams.new.create": "Team aanmaken",
  "teams.new.cancel": "Annuleren",
  "teams.new.nameNeeded": "Geef het team een naam.",
  "teams.nameTaken": "Er bestaat al een team met die naam.",
  "teams.created": "Team aangemaakt.",
  "teams.leadHint": "Dit zijn hun mensen: zij verdelen het werk van het team opnieuw en vallen voor iedereen in.",
  "teams.leadNeedsMember": "Je kunt alleen een team leiden waar je in zit.",
  "teams.noLead": "Geen leiding",
  "teams.gone": "Wie vertrokken is, kan niet aan een team worden toegevoegd.",
  "teams.locked": "U kunt teams niet wijzigen.",
  "screen.rules": "Regels",
  "screen.hr": "Personeelszaken",
  "sub.hr": "Zoek iedereen op. Werving, dossiers en alles daaronder zijn van personeelszaken.",
  "screen.team": "Rollen & team",
  "screen.audit": "Walliyo-audits",

  // ── Locked screen (opened by URL without the feature) ──
  "lock.requires": "Dit scherm vereist",
  "lock.or": " of ",
  "lock.roles": "Uw rollen ({roles}) bevatten dit niet, dus het staat niet in uw menu.",
  "lock.noRoles": "U hebt geen rol, dus het staat niet in uw menu.",

  // ── Sign-in ──
  "signIn.title": "Aanmelden bij de console",
  "signIn.subtitle": "Alleen voor het Walliyo-team. U ontvangt een code per sms.",
  "signIn.email": "Zakelijk e-mailadres",
  "signIn.password": "Wachtwoord",
  "signIn.submit": "Doorgaan",
  "signIn.submitting": "Controleren…",
  "verify.title": "Verificatiecode",
  "verify.subtitle": "We hebben een code per sms gestuurd naar {phone}.",
  "verify.code": "Code uit de sms",
  "verify.submit": "Aanmelden",
  "verify.submitting": "Controleren…",
  "verify.expiresIn": "De code verloopt over {time}.",
  "verify.expired": "De code is verlopen. Meld u opnieuw aan om een nieuwe te ontvangen.",
  "verify.restart": "Opnieuw aanmelden",

  // ── Errors: what failed and what to do (ADR-0016 §2.5) ──
  "error.requestId": "Verzoek-ID: {id}",
  "error.noRequestId": "Geen verzoek-ID: de server heeft niet geantwoord.",
  "error.signIn.unauthenticated": "E-mailadres of wachtwoord onjuist. Controleer ze en probeer het opnieuw.",
  "error.signIn.validation_error": "Voer een geldig e-mailadres en wachtwoord in.",
  "error.verify.validation_error": "Voer de 6-cijferige code uit de sms in.",
  "error.verify.session_expired": "De code is verlopen. Meld u opnieuw aan om een nieuwe te ontvangen.",
  "error.verify.unauthenticated": "Dit codeverzoek is niet meer geldig. Meld u opnieuw aan.",
  "error.unauthenticated": "U bent niet meer aangemeld. Meld u opnieuw aan.",
  "error.session_expired": "Uw sessie is verlopen. Meld u opnieuw aan.",
  "error.feature_not_enabled": "Uw rollen staan deze actie niet toe. Vraag een leidinggevende om toegang.",
  "error.invalid_code": "Onjuiste code. Controleer de sms en voer de code opnieuw in.",
  "error.too_many_attempts": "Te veel pogingen. Wacht enkele minuten en meld u dan opnieuw aan.",
  "error.stale_version": "Dit is gewijzigd terwijl u het bekeek. Laad opnieuw om de huidige versie te zien.",
  "error.validation_error": "Sommige gegevens zijn ongeldig. Corrigeer ze en probeer het opnieuw.",
  "error.internal_error":
    "De server heeft een fout gemaakt. Probeer het opnieuw; blijft het gebeuren, geef dan de ID hieronder door aan het technische team.",
  "error.network_error":
    "Geen antwoord van de server na meerdere pogingen. Controleer uw verbinding en probeer het opnieuw.",
  "error.network_error.write":
    "Geen antwoord van de server: het verzoek is mogelijk toch uitgevoerd. Probeer het opnieuw; het wordt niet twee keer uitgevoerd.",
  "error.unexpected_response":
    "Onverwacht antwoord van de server. Probeer het opnieuw; blijft het gebeuren, geef dan de ID hieronder door aan het technische team.",
  "error.unknown":
    "Er is een onverwachte fout opgetreden in de console. Laad de pagina opnieuw; blijft het gebeuren, waarschuw dan het technische team.",

  "sub.cases": "Gedeelde wachtrij · telefoon, e-mail en chat op één plek",

  "sub.customers": "Een klant of pro zoeken en het hele account bekijken",

  "sub.verifications": "De identiteit van pro's controleren voordat ze vindbaar zijn",

  "sub.reports": "Meldingen over pro's of klanten, naar ernst",

  "sub.billing": "Prijzen per land, acties en kortingen · een vakman houdt de prijs waarvoor hij afsloot",
  "sub.payments": "Kosten voor pro's · Orange Money en kaart",

  "sub.features": "In- of uitschakelen per niveau: iedereen, een regio, een versie, één persoon",

  "sub.rules": "Waarden van het bedrijf · elke wijziging maakt een nieuwe versie",

  // ── Fonctionnalités ──
  "features.title": "Functieactiveringen",
  "features.loading": "Functies laden…",
  "features.loadFailed": "De functies konden niet worden geladen.",
  "features.retry": "Opnieuw proberen",
  "features.close": "Sluiten",
  "features.pick": "Kies een functie om de uitzonderingen te zien.",
  "features.notFound": "Deze functie bestaat niet (meer). Kies er een uit de lijst.",
  "features.subject.for": "Record",
  "features.subject.allClients": "Alle klanten",
  "features.subject.allPros": "Alle pro's",
  "features.subject.user": "Gebruiker",
  "features.subject.uuid": "UUID",
  "features.subject.uuidHint": "31290388",
  "features.subject.unknown": "UUID niet gevonden.",
  "features.kind.client": "Klant",
  "features.kind.pro": "Pro",
  "features.col.source": "Bron",
  "features.col.value": "Waarde",
  "features.col.category": "Categorie",
  "features.value.on": "Aan",
  "features.value.off": "Uit",
  "features.source.default": "Standaard",
  "features.source.thisUser": "Deze gebruiker",
  "features.source.user": "Eén gebruiker",
  "features.source.allClients": "Alle klanten",
  "features.source.allPros": "Alle pro's",
  "features.source.proProfile": "Pro-profiel",
  "features.source.region": "Regio",
  "features.source.appVersion": "App-versie",
  "features.source.system": "Systeem",
  "features.locked.owner": "Alleen een Owner kan dit wijzigen",
  "features.locked.scope": "Niet in te stellen op dit niveau",
  "features.save.discard": "Verwerpen",
  "features.save.sending": "Opslaan…",
  "features.save.nothing": "Niets op te slaan: geen wijziging.",
  "features.save.locked": "Een van de wijzigingen is niet aan u.",
  "features.save.reasonNeeded": "Zeg in een paar woorden waarom.",
  "features.save.leave": "U hebt niet-opgeslagen wijzigingen.",
  "features.clear": "Terug naar de overgeërfde waarde",
  "features.cleared": "Wordt gewist",
  "features.filter.any": "Alle",
  "features.filter.own": "Hier ingesteld",
  "features.filter.inherited": "Overgeërfd",
  "features.filter.search": "Zoeken",
  "features.filter.none": "Geen functie voldoet aan deze filters.",
  "features.surface.app": "Walliyo-app",
  "features.surface.console": "Walliyo-console",
  "features.save.title.one": "1 niet-opgeslagen wijziging",
  "features.save.title.many": "{count} niet-opgeslagen wijzigingen",
  "features.save.submit.one": "1 wijziging opslaan",
  "features.save.submit.many": "{count} wijzigingen opslaan",
  "features.save.done.one": "1 wijziging opgeslagen.",
  "features.save.done.many": "{count} wijzigingen opgeslagen.",
  "features.unsaved": "niet opgeslagen",
  "features.surface.consoleSoon":
    "De {count} consolefuncties zijn voorlopig alleen per rol in te stellen. Per persoon komt hier.",
  "features.surface.consoleWhere": "Rollen & team openen",
  "features.subject.isStaff":
    "Dat nummer hoort bij een Walliyo-medewerker. Zijn functies staan op het tabblad Walliyo-console.",
  "features.subject.search": "Zoeken",
  "features.subject.searching": "Zoeken…",
  "features.subject.needsUuid": "Typ de acht cijfers van de UUID.",
  "features.subject.pickFirst": "Kies voor wie en zoek dan.",
  "features.subject.stale": "Deze resultaten komen van uw vorige zoekopdracht. Zoek opnieuw om ze bij te werken.",
  "features.pill.allClients": "Alle klantrecords",
  "features.pill.allPros": "Alle pro-records",
  "features.pill.unknown": "Onbekende gebruiker",
  "features.pill.staff": "Walliyo-medewerker",
  "features.subject.allStaff": "Alle medewerkers",
  "features.subject.staffMember": "Medewerker",
  "features.staffSource.override": "Uitzondering",
  "features.staffSource.byRole": "Via rol",
  "features.staffSource.byRoleNamed": "Via rol: {roles}",
  "features.staffSource.allStaff": "Alle medewerkers",
  "features.locked.ownAccount": "U kunt uw eigen account niet wijzigen",
  "features.locked.grant": "Deze mag u niet toekennen",
  "features.pill.allStaff": "Alle medewerkerrecords",
  "features.pill.unknownStaff": "Onbekende medewerker",
  "features.subject.isCustomer":
    "Dat nummer hoort bij een klant, niet bij een medewerker. Zijn functies staan op het tabblad Walliyo-app.",
  "features.subject.employeeUuid": "Medewerker-UUID",
  "features.subject.staffUuidHint": "27217102",
  "features.col.feature": "Functie",
  "features.col.default": "Standaard",
  "features.col.exceptions": "Uitzonderingen",
  "features.for.clients": "Voor klanten",
  "features.for.pros": "Voor pro's",
  "features.for.everyone": "Voor iedereen",
  "features.on": "Aan",
  "features.off": "Uit",
  "features.planned": "Gepland",
  "features.planned.note": "Gepland: er kan een waarde worden ingesteld, maar nog geen code leest die.",
  "features.detail.default": "Standaard: {value}",
  "features.sensitivity.open": "Gevoeligheid {level}: iedereen die app-functies beheert, kan dit wijzigen.",
  "features.sensitivity.critical":
    "Kritieke gevoeligheid: alleen een eigenaar kan dit wijzigen, en de eigenaars worden op de hoogte gebracht.",
  "features.locked.critical":
    "Vergrendeld: deze functie is kritiek, alleen een eigenaar kan die wijzigen. Uw rollen ({roles}) maken u geen eigenaar; de server zou ook weigeren.",
  "features.exceptions.title": "Uitzonderingen per bereik",
  "features.col.scope": "Bereik",
  "features.col.target": "Doel",
  "features.col.reason": "Reden",
  "features.col.expires": "Verloopt",
  "features.col.actions": "Beheren",
  "features.default.scope": "Standaard",
  "features.default.reason": "standaardwaarde",
  "features.exceptions.none": "Geen uitzonderingen: de standaardwaarde geldt voor iedereen.",
  "features.expired": "Verlopen",
  "features.expires.never": "Tot wijziging",
  "features.edit": "Wijzigen",
  "features.remove": "Verwijderen",
  "features.add": "Uitzondering toevoegen",
  "features.scope.system": "Systeem",
  "features.scope.allClients": "Alle klanten",
  "features.scope.allPros": "Alle pro's",
  "features.scope.region": "Regio",
  "features.scope.appVersion": "App-versie",
  "features.scope.user": "Eén persoon",
  "features.scope.proProfile": "Eén pro-profiel",
  "features.scope.clientProfile": "Eén klantprofiel",
  "features.target.everyone": "Iedereen",
  "features.target.allClients": "Alle klanten",
  "features.target.allPros": "Alle pro's",
  "features.target.appVersion": "Versie {version} en nieuwer",
  "features.target.unnamed": "Account zonder naam",
  "features.form.addTitle": "Nieuwe uitzondering",
  "features.form.editTitle": "Uitzondering wijzigen",
  "features.form.scope": "Bereik",
  "features.form.scopePick": "Kies een bereik…",
  "features.form.scopeUnsupported": "{scope} (nog niet mogelijk)",
  "features.form.clientProfileNote":
    "Een klantprofiel kan nog geen waarde krijgen: klantprofielen bestaan nog niet. Kies voor één klant „Eén persoon”.",
  "features.form.needsSearch": "Een persoon of pro-profiel kiezen vereist",
  "features.form.needsView": "Het pro-profiel van een account vinden vereist",
  "features.form.region": "Regio",
  "features.form.regionPick": "Kies een regio…",
  "features.form.appVersion": "Vanaf versie",
  "features.form.appVersionHint": "Bijvoorbeeld 2.4.0: geldt voor die versie en nieuwere.",
  "features.form.person": "Persoon",
  "features.form.pro": "Pro-profiel",
  "features.form.search": "Zoeken",
  "features.form.searching": "Zoeken…",
  "features.form.searchPlaceholder": "Naam, telefoon, e-mail of account-ID",
  "features.form.noResults": "Geen account gevonden.",
  "features.form.pickedChange": "Wijzigen",
  "features.form.value": "Waarde",
  "features.form.reason": "Reden (verplicht)",
  "features.form.reasonHint": "Wordt met de wijziging in het auditlogboek vastgelegd.",
  "features.form.expires": "Verloopt op",
  "features.form.expiresHint": "Optioneel. Leeg: tot wijziging.",
  "features.form.version": "Gebaseerd op versie {version} van deze uitzondering.",
  "features.form.submitAdd": "Uitzondering toevoegen",
  "features.form.submitEdit": "Opslaan",
  "features.form.cancel": "Annuleren",
  "features.form.sending": "Verzenden…",
  "features.problem.scope": "Kies een van de aangeboden bereiken.",
  "features.problem.region": "Kies een regio.",
  "features.problem.appVersion": "Voer een versie in zoals 2.4.0.",
  "features.problem.person": "Zoek de persoon en kies die uit de resultaten.",
  "features.problem.pro": "Zoek de pro en kies een account met een pro-profiel.",
  "features.problem.exists": "Er is al een uitzondering voor dit doel: wijzig die.",
  "features.problem.reason": "Geef in een paar woorden een reden.",
  "features.problem.expiryInvalid": "Deze vervaldatum is ongeldig.",
  "features.problem.expiryPast": "De vervaldatum moet in de toekomst liggen, of laat die leeg.",
  "features.refused.critical": "Geweigerd: deze functie is kritiek, alleen een eigenaar kan die wijzigen.",
  "features.refused.scopeNotSupported":
    "Geweigerd: een klantprofiel kan nog geen waarde krijgen, klantprofielen bestaan nog niet. Kies „Eén persoon”.",
  "features.refused.scopeNotAllowed":
    "Geweigerd: deze functie kan niet op dit bereik worden ingesteld. Kies een van de aangeboden bereiken.",
  "features.refused.expiryInPast":
    "Geweigerd: de vervaldatum ligt in het verleden. Kies een latere datum of laat die leeg.",
  "features.refused.targetNotFound": "Geweigerd: dat account of pro-profiel bestaat niet meer. Zoek het opnieuw.",
  "features.stale":
    "Iemand heeft deze functie intussen gewijzigd. Laad opnieuw om de huidige uitzonderingen te zien en probeer het nog eens.",
  "features.done.added": "Uitzondering toegevoegd.",
  "features.done.saved": "Uitzondering opgeslagen.",
  "features.done.removed": "Uitzondering verwijderd: het bredere bereik of de standaardwaarde geldt weer.",
  "features.remove.title": "Uitzondering verwijderen",
  "features.remove.body":
    "De uitzondering „{scope} · {target}: {value}” van {feature} verwijderen. Daarna geldt weer het bredere bereik of de standaardwaarde.",
  "features.remove.submit": "Verwijderen",

  // ── Règles ──
  "rules.loading": "Regels laden…",
  "rules.loadFailed": "De regels konden niet worden geladen.",
  "rules.retry": "Opnieuw proberen",
  "rules.pick": "Kies een regel om de geschiedenis te zien.",
  "rules.notFound": "Deze regel bestaat niet. Kies er een uit de lijst.",
  "rules.next": "vanaf {date}: {value}",
  "rules.now": "Nu van kracht",
  "rules.default": "standaardwaarde",
  "rules.kind.gnf": "bedrag in GNF",
  "rules.kind.minutes": "duur in minuten",
  "rules.kind.hours": "duur in uren",
  "rules.kind.days": "duur in dagen",
  "rules.kind.km": "afstand in km",
  "rules.kind.number": "getal",
  "rules.kind.boolean": "ja of nee",
  "rules.kind.choice": "keuze uit een lijst",
  "rules.kind.text": "tekst",
  "rules.sensitivity.open": "Gevoeligheid {level}: iedereen die regels mag wijzigen, kan een versie maken.",
  "rules.sensitivity.critical": "Kritieke gevoeligheid: alleen een eigenaar kan een versie maken.",
  "rules.legalBasis.required": "Elke wijziging moet de rechtsgrond vermelden.",
  "rules.locked.critical":
    "Vergrendeld: deze regel is kritiek, alleen een eigenaar kan een versie maken. Uw rollen ({roles}) maken u geen eigenaar; de server zou ook weigeren.",
  "rules.locked.retired": "Deze regel is buiten gebruik: niets leest hem nog, hij kan niet meer veranderen.",
  "rules.history": "Versiegeschiedenis",
  "rules.history.none": "Geen versies: de standaardwaarde ({value}) geldt.",
  "rules.col.version": "Versienr.",
  "rules.col.value": "Waarde",
  "rules.col.effective": "Van kracht",
  "rules.col.reason": "Reden",
  "rules.col.legalBasis": "Rechtsgrond",
  "rules.col.by": "Door",
  "rules.status.scheduled": "Vanaf {date}",
  "rules.status.current": "Huidig",
  "rules.status.since": "sinds {date}",
  "rules.status.past": "Vervangen",
  "rules.new": "Nieuwe versie",
  "rules.form.title": "Nieuwe versie",
  "rules.form.value": "Nieuwe waarde",
  "rules.form.value.gnf": "Nieuw bedrag (GNF)",
  "rules.form.value.minutes": "Nieuwe waarde (in minuten)",
  "rules.form.value.hours": "Nieuwe waarde (in uren)",
  "rules.form.value.days": "Nieuwe waarde (in dagen)",
  "rules.form.effective": "Gaat in",
  "rules.form.now": "Nu meteen",
  "rules.form.at": "Op een datum en tijdstip",
  "rules.form.atLabel": "Van kracht op",
  "rules.form.reason": "Reden (verplicht)",
  "rules.form.legalBasis": "Rechtsgrond (verplicht)",
  "rules.form.legalBasisOptional": "Rechtsgrond (indien van toepassing)",
  "rules.form.legalBasisPlaceholder": "Wet, contract, juridisch advies",
  "rules.form.version":
    "Gebaseerd op versie {version} van de regel: als er intussen een andere versie wordt toegevoegd, wordt dit geweigerd.",
  "rules.form.submit": "Versie maken",
  "rules.form.cancel": "Annuleren",
  "rules.form.sending": "Verzenden…",
  "rules.value.true": "Ja",
  "rules.value.false": "Nee",
  "rules.problem.value": "Voer een waarde in.",
  "rules.problem.number": "Voer een getal in, bijvoorbeeld 750000.",
  "rules.problem.integer": "Voer een geheel getal in.",
  "rules.problem.min": "De waarde moet minstens {min} zijn.",
  "rules.problem.max": "De waarde mag hoogstens {max} zijn.",
  "rules.problem.choice": "Kies een waarde uit de lijst.",
  "rules.problem.tooLong": "Hoogstens {max} tekens.",
  "rules.problem.effectiveMissing": "Kies de datum en het tijdstip waarop het ingaat.",
  "rules.problem.effectivePast":
    "Een versie kan niet in het verleden ingaan: wat toen gold, blijft vastgelegd. Kies nu of later.",
  "rules.problem.reason": "Geef in een paar woorden een reden.",
  "rules.problem.legalBasis": "Vermeld de wet, het contract of het juridisch advies achter deze wijziging.",
  "rules.refused.critical": "Geweigerd: deze regel is kritiek, alleen een eigenaar kan een versie maken.",
  "rules.refused.effectivePast": "Geweigerd: die datum ligt in het verleden. Kies nu of later.",
  "rules.refused.legalBasis":
    "Geweigerd: deze regel vereist een rechtsgrond. Vermeld de wet, het contract of het juridisch advies.",
  "rules.refused.invalidValue": "Geweigerd: die waarde past niet bij de regel. Controleer de eenheid en het minimum.",
  "rules.refused.retired": "Geweigerd: deze regel is buiten gebruik, niets leest hem nog.",
  "rules.stale":
    "Intussen is er een andere versie van deze regel toegevoegd. Laad opnieuw om die te zien en probeer het nog eens.",
  "rules.done.now": "Versie {version} gemaakt: die geldt vanaf nu.",
  "rules.done.scheduled": "Versie {version} gemaakt: die geldt vanaf {date}.",

  "sub.team": "Elke rol is een lijst met functies. Niemand kan zichzelf iets toekennen.",

  "sub.audit": "Alles wat is gedaan, door wie, voor wie · uw raadpleging wordt zelf ook vastgelegd",

  // ── Audit log ──
  "audit.filter.subject": "Betrokkene",
  "audit.filter.subjectPlaceholder": "Account-ID",
  "audit.filter.staff": "Teamlid",
  "audit.filter.staffPlaceholder": "ID van het teamlid",
  "audit.filter.action": "Actie",
  "audit.filter.area": "Domein",
  "audit.filter.outcome": "Resultaat",
  "audit.filter.from": "Van",
  "audit.filter.to": "Tot en met",
  "audit.filter.all": "Alle",
  "audit.filter.allActions": "Alle",
  "audit.filter.clear": "Filters wissen",
  "audit.problem.id": "Een ID ziet eruit als 3f2a…-…-…-…-… (UUID). Kopieer het van de accountpagina.",
  "audit.problem.period": "Het einde van de periode ligt vóór het begin.",
  "audit.problem.needsPerson": "Geef de UUID van de wijziger, die van de persoon, of beide.",
  "audit.filtersAria": "Filters van het logboek",
  "audit.searchAria": "Zoeken in het logboek",
  "audit.scope.user": "Individu",
  "audit.scope.allStaff": "Alle medewerkers",
  "audit.scope.allClients": "Alle klanten",
  "audit.scope.allPros": "Alle pro's",
  "audit.scope.staffRole": "Rol",
  "audit.scope.proProfile": "Pro-profiel",
  "audit.scope.region": "Regio",
  "audit.scope.appVersion": "App-versie",
  "audit.scope.system": "Systeem",
  "audit.scope.staffMember": "Individu",
  "audit.filter.involving": "Betreft",
  "audit.filter.updaterUuid": "UUID van de wijziger",
  "audit.filter.userUuid": "UUID van de persoon",
  "audit.pill.updater": "Wijziger",
  "audit.pill.user": "Persoon",
  "audit.col.time": "Tijd",
  "audit.col.actor": "Wijziger",
  "audit.col.action": "Instelling",
  "audit.col.subject": "Betreft",
  "audit.col.outcome": "Resultaat",
  "audit.col.reason": "Reden",
  "audit.filter.effect": "Tonen",
  "audit.effect.write": "Wijzigingen",
  "audit.effect.read": "Inzages",
  "audit.col.before": "Voor",
  "audit.col.after": "Na",
  "audit.change.arrow": "{before} → {after}",
  "audit.change.field": "{key}: {value}",
  "audit.outcome.succeeded": "Gelukt",
  "audit.outcome.denied": "Geweigerd",
  "audit.outcome.requested": "Aangevraagd",
  "audit.actor.staff": "Teamlid",
  "audit.actor.noRoles": "geen rol",
  "audit.actor.customer": "klant",
  "audit.actor.self": "klant (zelf)",
  "audit.actor.system": "Systeem",
  "audit.subject.onBehalf": "namens {id}",
  "audit.filterBy": "Filteren op {id}",
  "audit.subject.open": "Account van {name} openen",
  "audit.masked": "verborgen",
  "audit.sensitive": "🔒 gevoelig",
  "audit.loading": "Logboek laden…",
  "audit.loadFailed": "Het logboek kon niet worden geladen.",
  "audit.retry": "Opnieuw proberen",
  "audit.empty": "Geen vermeldingen komen overeen met deze filters.",
  "audit.emptyForPerson": "Geen vermelding voor deze zoekopdracht.",
  "audit.fixProblems": "Corrigeer de gemarkeerde filters om het logboek te tonen.",
  "audit.loadMore": "Meer laden",
  "audit.loadingMore": "Laden…",
  "audit.moreFailed": "De volgende pagina kon niet worden geladen. De getoonde vermeldingen blijven geldig.",
  "audit.count": "{count} vermeldingen getoond",
  "audit.countOne": "1 vermelding getoond",
  "audit.end": "Einde van het logboek voor deze filters.",
  "audit.recorded": "Uw raadpleging wordt zelf ook vastgelegd (VIEW_AUDIT_LOG_STAFF_ACTION), met de gebruikte filters.",
  "audit.sensitiveShown": "U ziet de gevoelige waarden (VIEW_SENSITIVE_AUDIT_VALUES).",
  "audit.sensitiveHidden":
    "Gevoelige waarden zijn verborgen: daarvoor is VIEW_SENSITIVE_AUDIT_VALUES nodig, dat alleen de eigenaar toekent.",
  "audit.deniedNote": "Een regel „Geweigerd” laat zien dat ook een poging zonder recht wordt vastgelegd.",
  "area.account": "Account",
  "area.access": "Toegang",
  "area.onboarding": "Registratie pro",
  "area.discovery": "Zoeken",
  "area.jobs": "Aanvragen",
  "area.leads": "Kansen",
  "area.messaging": "Berichten",
  "area.reviews": "Beoordelingen",
  "area.payments": "Betalingen",
  "area.support": "Dossiers",
  "area.safety": "Veiligheid",
  "area.settings": "Instellingen",
  "area.staff": "Team",
  "area.audit": "Audit",

  // ── Roles & team ──
  "team.members": "Team",
  "team.col.name": "Naam",
  "team.col.roles": "Rollen",
  "team.col.status": "Status",
  "team.col.lastSeen": "Laatste aanmelding",
  "team.you": "u",
  "team.noRoles": "Geen rol",
  "team.status.active": "Actief",
  "team.status.invited": "Uitgenodigd",
  "team.status.deactivated": "Gedeactiveerd",
  "team.sessions": "{count} open sessies",
  "team.sessionsOne": "1 open sessie",
  "team.lastSeen.never": "Nooit aangemeld",
  "team.lastSeen.today": "vandaag om {time}",
  "team.lastSeen.yesterday": "gisteren om {time}",
  "team.lastSeen.date": "op {date}",
  "team.invite": "Uitnodigen",
  "team.manageRoles": "Rollen",
  "team.endSessions": "Sessie beëindigen",
  "team.deactivate": "Deactiveren",
  "team.loading": "Team laden…",
  "team.loadFailed": "Het team kon niet worden geladen.",
  "team.retry": "Opnieuw proberen",
  "team.emptyStaff": "Nog niemand in het team.",
  "team.grid": "Rollen × functies",
  "team.grid.feature": "Functie",
  "team.grid.editable": "Klik om toe te kennen of in te trekken · „critical” vereist de eigenaar",
  "team.grid.readOnly": "🔒 Alleen lezen · wijzigen vereist MANAGE_ROLES of ASSIGN_ROLES",
  "team.grid.members": "{count} leden",
  "team.grid.membersOne": "1 lid",
  "team.grid.yourRole": "🔒 uw rol",
  "team.grid.newRole": "Nieuwe rol",
  "team.grid.editRole": "Wijzigen",
  "team.grid.noRoles": "Er bestaat nog geen rol.",
  "team.lock.ownRole": "U hebt deze rol: niemand wijzigt wat de eigen rol toekent.",
  "team.lock.critical": "Kritiek: alleen de eigenaar kan dit toekennen of intrekken.",
  "team.lock.high": "Hoge gevoeligheid: u hebt MANAGE_ROLES nodig en moet deze functie zelf hebben.",
  "team.lock.low": "U hebt MANAGE_ROLES of ASSIGN_ROLES nodig.",
  "team.lock.criticalShort": "🔒 eigenaar",
  "team.lock.highShort": "🔒 buiten uw rechten",
  "team.cell.grant": "{feature} toekennen aan de rol {role}",
  "team.cell.revoke": "{feature} intrekken bij de rol {role}",
  "team.sensitivity.low": "low",
  "team.sensitivity.high": "high",
  "team.sensitivity.critical": "critical",

  "team.reason": "Reden",
  "team.reasonHint": "Vastgelegd in het auditlogboek. Een paar woorden volstaan.",
  "team.reasonTooShort": "Geef een reden van minstens 3 tekens.",
  "team.cancel": "Annuleren",
  "team.close": "Sluiten",
  "team.sending": "Verzenden…",
  "team.reload": "Opnieuw laden",
  "team.refused": "Geweigerd: {message}",
  "team.stale":
    "Iemand heeft dit intussen gewijzigd. Laad opnieuw om de huidige versie te zien en probeer het dan opnieuw.",

  "team.grant.title": "Een functie toekennen",
  "team.revoke.title": "Een functie intrekken",
  "team.grant.body": "{feature} toekennen aan de rol {role} ({members}).",
  "team.revoke.body": "{feature} intrekken bij de rol {role} ({members}).",
  "team.grant.submit": "Toekennen",
  "team.revoke.submit": "Intrekken",
  "team.grant.done": "{feature} toegekend aan de rol {role}.",
  "team.revoke.done": "{feature} ingetrokken bij de rol {role}.",
  "team.critical.note": "Kritieke functie: de eigenaars worden op de hoogte gebracht.",

  "team.invite.title": "Een teamlid uitnodigen",
  "team.invite.name": "Volledige naam",
  "team.invite.email": "Zakelijk e-mailadres",
  "team.invite.phone": "Telefoon",
  "team.invite.phoneHint": "Internationaal formaat, bijv. +224621234567.",
  "team.invite.roles": "Rollen",
  "team.invite.noRoles": "Maak eerst een rol aan — u kunt nu uitnodigen en later rollen toekennen.",
  "team.invite.rolesHint": "Zonder rol opent er een console waarin niets toegankelijk is.",
  "team.invite.sms":
    "Er wordt een 6-cijferige code per sms naar dit nummer gestuurd. Deze is {hours} uur geldig en laat de persoon een wachtwoord kiezen op de pagina „Mijn wachtwoord kiezen”.",
  "team.invite.submit": "Uitnodiging versturen",
  "team.invite.done": "{name} is uitgenodigd. Code per sms verstuurd, geldig tot {until}.",
  "team.invite.missing": "Vul de naam, het e-mailadres en het telefoonnummer in.",

  "team.deactivate.title": "{name} deactiveren",
  "team.deactivate.body":
    "{name} kan zich nooit meer aanmelden. Open sessies en een eventuele uitnodiging eindigen onmiddellijk. Een gedeactiveerd teamlid wordt niet verwijderd.",
  "team.deactivate.submit": "Deactiveren",
  "team.deactivate.done": "{name} is gedeactiveerd. Beëindigde sessies: {count}.",
  "team.reactivate": "Heractiveren",
  "team.reactivate.title": "{name} heractiveren",
  "team.reactivate.body":
    "{name} kan weer inloggen, met de rollen die hij of zij al had. Het inloggen begint opnieuw: geen sessie of code wordt hersteld.",
  "team.reactivate.submit": "Heractiveren",
  "team.reactivate.done": "{name} is weer actief.",

  "team.endSessions.title": "Sessies van {name} beëindigen",
  "team.endSessions.body": "{name} wordt overal afgemeld ({sessions}).",
  "team.endSessions.self": "Dit zijn uw eigen sessies: u wordt ook afgemeld.",
  "team.endSessions.submit": "Beëindigen",
  "team.endSessions.done": "Sessies van {name} beëindigd: {count}.",

  "team.roles.title": "Rollen van {name}",
  "team.roles.held": "Huidige rollen",
  "team.roles.available": "Andere rollen",
  "team.roles.none": "Geen",
  "team.roles.assign": "{role} toewijzen",
  "team.roles.remove": "{role} intrekken",
  "team.roles.assignDone": "{role} toegewezen aan {name}.",
  "team.roles.removeDone": "{role} ingetrokken bij {name}.",
  "team.roles.reasonFirst": "Geef eerst een reden en kies dan de rol die u wilt toewijzen of intrekken.",

  "team.role.createTitle": "Nieuwe rol",
  "team.role.editTitle": "Rol {name} wijzigen",
  "team.role.name": "Naam van de rol",
  "team.role.description": "Beschrijving",
  "team.role.descriptionHint": "Optioneel. Wat deze rol doet, in één zin.",
  "team.role.department": "Afdeling",
  "team.role.noDepartment": "Geen",
  "team.role.departmentHint":
    "De werkruimte waar de houders binnenkomen. Wat de rol mag, bepalen nog steeds de functies.",
  "team.role.create": "Rol aanmaken",
  "team.role.save": "Opslaan",
  "team.role.created": "Rol {name} aangemaakt. Ken er functies aan toe in het raster.",
  "team.role.saved": "Rol {name} opgeslagen.",
  "team.role.nameTooShort": "De naam heeft minstens 2 tekens.",
  "team.role.unchanged": "Wijzig de naam of de beschrijving.",
  "team.role.version": "Versie {version}",

  // ── Permissions on a role (ADR-0019) and who can do this ──
  "team.tab.roles": "Rollen & team",
  "team.tab.who": "Wie mag dit",
  "team.tabs.aria": "Onderdelen van het team",
  "team.permission.noLimit": "Geen limiet",
  "team.permission.lockFeature": "Ken {feature} eerst toe aan {role}: een machtiging telt alleen onder haar functie.",
  "team.cell.grantPermission": "{permission} toekennen aan de rol {role}",
  "team.cell.editPermission": "{permission} wijzigen voor de rol {role}",
  "team.permission.grantTitle": "Een machtiging toekennen",
  "team.permission.editTitle": "Een machtiging wijzigen",
  "team.permission.grantBody": "{permission} toekennen aan de rol {role} ({members}).",
  "team.permission.editBody": "De rol {role} ({members}) heeft {permission}.",
  "team.permission.under": "Onder {feature}.",
  "team.permission.approvable": "Zonder deze wordt hun poging een goedkeuringsverzoek.",
  "team.permission.refusable": "Zonder deze wordt de handeling geweigerd.",
  "team.permission.limits": "Limieten",
  "team.permission.limitsHint":
    "Het hoogste dat de houders per valuta alleen mogen doen. Daarboven, of in een valuta zonder limiet, wordt het een goedkeuringsverzoek.",
  "team.permission.noLimitHint": "Geen limiet: de houders handelen alleen, ongeacht het bedrag.",
  "team.permission.currency": "Valuta",
  "team.permission.amount": "Bedrag",
  "team.permission.addLimit": "Een limiet in een andere valuta toevoegen",
  "team.permission.removeLimit": "De limiet in {currency} verwijderen",
  "team.permission.limitProblem": "Geef voor elke limiet een valuta van drie letters en een bedrag boven nul.",
  "team.permission.duplicateCurrency": "Eén limiet per valuta: {currency} staat er twee keer in.",
  "team.permission.grantDone": "{permission} toegekend aan de rol {role}.",
  "team.permission.revokeDone": "{permission} ingetrokken bij de rol {role}.",
  "team.revoke.permissionsToo": "De machtigingen eronder gaan mee: {permissions}.",
  "team.refused.sensitivity":
    "Je toegang staat het toekennen of intrekken hiervan niet toe. Vraag een Ops Manager of de eigenaar.",
  "team.refused.critical": "Kritiek: alleen een eigenaar die het zelf heeft, kent het toe of trekt het in.",
  "team.refused.limitAboveOwn": "Je kunt geen hogere limiet toekennen dan je eigen. Vraag de eigenaar.",
  "team.refused.featureFirst":
    "Deze machtiging staat op een functie die de rol niet toekent. Ken eerst de functie toe.",
  "team.refused.notLimited": "Deze machtiging draagt geen limiet.",
  "team.refused.limitWithoutGrant": "Een limiet hoort bij een toegekende machtiging.",
  "team.refused.ownRole": "Je hebt deze rol, dus je kunt niet wijzigen wat ze toekent. Vraag een andere eigenaar.",
  "team.who.action": "Actie",
  "team.who.feature": "Functie",
  "team.who.permission": "Machtiging",
  "team.who.noPermission": "Geen machtiging dekt deze actie: wie de functie heeft, mag ze uitvoeren.",
  "team.who.approvable": "kan aangevraagd worden",
  "team.who.col.through": "Via",
  "team.who.col.limit": "Limiet",
  "team.who.personal": "Voor deze persoon ingesteld",
  "team.who.mayRequest": "Mag alleen vragen: wordt een goedkeuringsverzoek",
  "team.who.loading": "Laden wie dit mag…",
  "team.who.loadFailed": "Kon niet laden wie dit mag.",
  "team.who.empty": "Niemand mag dit.",

  // ── Customers & pros ──
  // Trades, by WorkerCategory.
  "trade.electrician": "Elektricien",
  "trade.plumber": "Loodgieter",
  "trade.mason": "Metselaar",
  "trade.carpenter": "Timmerman",
  "trade.ac_technician": "Airco-technicus",
  "trade.cleaner": "Schoonmaker",
  "trade.painter": "Schilder",
  "trade.handyman": "Klusjesman",
  "trade.laundry": "Wasserij",
  "trade.babysitter": "Oppas",
  "trade.fridge_repair": "Koelkastreparateur",
  "trade.moto_driver": "Motortaxi",
  "trade.tailor": "Kleermaker",
  "trade.car_mechanic": "Automonteur",
  "trade.welder": "Lasser",
  "trade.gardener": "Tuinman",
  "trade.phone_repair": "Telefoonreparateur",
  "trade.tutor": "Bijlesdocent",
  "trade.hairdresser": "Kapper",
  "trade.security_guard": "Bewaker",
  "trade.other": "Overig",
  // A number with its unit (the settings' Unit).
  "unit.km": "{value} km",
  "unit.minutes": "{value} min",
  "unit.hours": "{value} u",
  "unit.days": "{value} d",
  "unit.seconds": "{value} s",

  "customers.search.label": "Een klant of pro zoeken",
  "customers.search.placeholder": "Naam, telefoon, e-mail of account-ID",
  "customers.search.hint": "Bijv. „621 23 45 67”, „Sékou Touré”, „mariama.bah@” of de account-ID.",
  "customers.search.submit": "Zoeken",
  "customers.search.tooShort": "Voer minstens 2 tekens in.",
  "customers.search.locked": "Zoeken vereist",
  "customers.search.idle": "Voer een naam, nummer, e-mailadres of ID in om een account te vinden.",
  "customers.search.loading": "Zoeken…",
  "customers.search.loadFailed": "De zoekopdracht is mislukt.",
  "customers.search.empty": "Geen account komt overeen met „{query}”.",
  "customers.search.matchedBy.userId": "Gezocht op account-ID",
  "customers.search.matchedBy.email": "Gezocht op e-mail",
  "customers.search.matchedBy.phone": "Gezocht op telefoon",
  "customers.search.matchedByPhone": "Gezocht op telefoon: {phone}",
  "customers.search.matchedBy.name": "Gezocht op naam",
  "customers.search.count": "{count} accounts getoond",
  "customers.search.countOne": "1 account getoond",
  "customers.search.end": "Einde van de resultaten.",
  "customers.search.loadMore": "Meer laden",
  "customers.search.loadingMore": "Laden…",
  "customers.search.moreFailed": "De volgende pagina kon niet worden geladen. De getoonde accounts blijven geldig.",
  "customers.search.retry": "Opnieuw proberen",
  "customers.search.masked":
    "Nummers en e-mailadressen zijn verborgen. „Tonen”, op de accountpagina en met een reden, wordt vastgelegd.",
  "customers.col.name": "Naam",
  "customers.col.contact": "Contact",
  "customers.col.kind": "Klant of pro",
  "customers.col.region": "Regio",
  "customers.col.since": "Lid sinds",
  "customers.deleted": "Account verwijderd",
  "customers.deletedName": "Naam gewist",
  "customers.kind.client": "Klant",
  "customers.kind.pro": "Pro",
  "customers.kind.proAndClient": "Pro en klant",
  "customers.kind.admin": "Beheerder",
  "customers.region.gn": "Guinee",
  "customers.region.sn": "Senegal",
  "customers.region.us": "Verenigde Staten",
  "customers.region.eu": "Europa",
  "customers.verification.unverified": "Niet geverifieerd",
  "customers.verification.pending": "In behandeling",
  "customers.verification.verified": "Geverifieerd",
  "customers.verification.rejected": "Afgewezen",

  "customers.back": "← Zoeken",
  "customers.page.loading": "Account laden…",
  "customers.page.loadFailed": "Het account kon niet worden geladen.",
  "customers.page.notFound": "Geen account heeft deze ID. Zoek de persoon opnieuw.",
  "customers.page.locked": "De accountpagina vereist",
  "customers.page.sub": "{kind} · lid sinds {since} · {region}",
  "customers.page.deletedTitle": "Account verwijderd",
  "customers.page.deletedSub": "Verwijderd op {date} · naam en contactgegevens gewist",

  "customers.reveal.button": "Tonen",
  "customers.reveal.locked": "🔒 verborgen",
  "customers.reveal.lockedTitle": "Contactgegevens tonen vereist REVEAL_CONTACT_DETAILS_STAFF_FEATURE_ENABLEMENT",
  "customers.reveal.title": "Contactgegevens van {name} tonen",
  "customers.reveal.body":
    "Het volledige nummer en e-mailadres verschijnen alleen op deze pagina, zolang u ze bekijkt. Het tonen wordt vastgelegd in het logboek van het account, met uw reden.",
  "customers.reveal.reason": "Reden",
  "customers.reveal.placeholder": "Waarom? bijv. klant terugbellen, dossier D-0142",
  "customers.reveal.tooShort": "Geef een reden van minstens 3 tekens.",
  "customers.reveal.submit": "Tonen",
  "customers.reveal.sending": "Verzenden…",
  "customers.reveal.cancel": "Annuleren",
  "customers.reveal.noAnswer":
    "Geen antwoord van de server: het tonen is mogelijk vastgelegd zonder dat de gegevens u bereikten. Probeer het opnieuw; ook een nieuwe weergave wordt vastgelegd.",
  "customers.reveal.recorded": "Getoond om {time} · raadpleging vastgelegd in het logboek van het account.",
  "customers.reveal.hide": "Verbergen",
  "customers.reveal.phone": "Telefoon:",
  "customers.reveal.email": "E-mail:",
  "customers.reveal.none": "geen",

  "customers.obo.title": "Namens {name} handelen",
  "customers.obo.body":
    "Er wordt een code per sms naar het nummer van het account gestuurd. De klant leest die hardop voor; de sessie duurt 30 minuten en elke actie wordt vastgelegd met zijn naam en de uwe.",
  "customers.obo.send": "Code versturen",
  "customers.obo.soon": "Binnenkort beschikbaar",

  "customers.tabs.aria": "Onderdelen van het account",
  "customers.tab.overview": "Overzicht",
  "customers.tab.subscription": "Abonnement",
  "customers.tab.settings": "Functies & instellingen",
  "customers.tab.jobs": "Aanvragen",
  "customers.tab.audit": "Logboek",

  "customers.pro.title": "Proprofiel",
  "customers.pro.none": "Geen proprofiel.",
  "customers.pro.identity": "Identiteit",
  "customers.pro.approval": "Goedkeuring",
  "customers.pro.rating": "Score",
  "customers.pro.ratingValue": "{rating} ★ · {count} beoordelingen",
  "customers.pro.noReviews": "Geen beoordelingen",
  "customers.pro.rate": "Tarief",
  "customers.pro.subscription": "Abonnement",
  "customers.pro.noSubscription": "Geen",
  "customers.pro.subscriptionLine": "{plan} · {status}",
  "customers.pro.paidUntil": "{plan} · betaald tot {date}",
  "customers.pro.endingUntil": "{plan} · actief tot {date}, loopt af",
  "customers.pro.approval.pending": "In behandeling",
  "customers.pro.approval.approved": "Goedgekeurd",
  "customers.pro.approval.rejected": "Afgewezen",
  "customers.subscription.pending": "in behandeling",
  "customers.subscription.active": "actief",
  "customers.subscription.ending": "loopt af",
  "customers.subscription.suspended": "geschorst",
  "customers.subscription.ended": "beëindigd",
  "customers.rate.hourly": "{amount} / uur",
  "customers.rate.daily": "{amount} / dag",
  "customers.rate.fixed": "{amount} vast bedrag",
  "customers.client.title": "Klantprofiel",
  "customers.client.jobsPosted": "Geplaatste aanvragen",
  "customers.client.lastActivity": "Laatste activiteit",
  "customers.client.never": "Geen",
  "customers.restrictions.title": "Actieve beperkingen",
  "customers.restrictions.none": "Geen beperkingen.",
  "customers.restrictions.suspension": "Voorlopige schorsing",
  "customers.restrictions.line": "{feature} uitgeschakeld voor {scope} · reden: {reason}",
  "customers.restrictions.until": "tot {date}",

  "customers.settings.col.setting": "Instelling",
  "customers.settings.col.value": "Waarde",
  "customers.settings.col.source": "Niveau",
  "customers.settings.col.reason": "Reden",
  "customers.settings.col.expires": "Verloopt",
  "customers.settings.on": "Ingeschakeld",
  "customers.settings.off": "Uitgeschakeld",
  "customers.settings.restricted": "Beperkt",
  "customers.settings.none": "Er geldt geen instelling voor dit account.",
  "customers.settings.edit": "Een instelling wijzigen",
  "customers.settings.editSoon":
    "Binnenkort beschikbaar: het wijzigen van de instellingen van een klant komt in een volgende versie.",
  "customers.settings.foot":
    "Het meest specifieke niveau wint: persoon, proprofiel, alle pro's of alle klanten, regio, systeem, en dan de standaardwaarde.",
  "customers.source.user": "Persoon",
  "customers.source.proProfile": "Proprofiel",
  "customers.source.allPros": "Alle pro's",
  "customers.source.allClients": "Alle klanten",
  "customers.source.region": "Regio",
  "customers.source.regionOf": "Regio {region}",
  "customers.source.appVersion": "Appversie",
  "customers.source.system": "Systeem",
  "customers.source.default": "Standaard",
  "customers.scope.user": "de persoon",
  "customers.scope.proProfile": "het proprofiel",

  "customers.jobs.col.trade": "Vakgebied",
  "customers.jobs.col.type": "Type",
  "customers.jobs.col.side": "Rol",
  "customers.jobs.col.other": "Met",
  "customers.jobs.col.status": "Status",
  "customers.jobs.col.date": "Datum",
  "customers.jobs.type.direct": "Direct",
  "customers.jobs.type.open": "Open",
  "customers.jobs.side.client": "Klant",
  "customers.jobs.side.pro": "Pro",
  "customers.jobs.status.requested": "Aangevraagd",
  "customers.jobs.status.quoted": "Offerte verstuurd",
  "customers.jobs.status.accepted": "Introductie gedaan",
  "customers.jobs.status.cancelled": "Geannuleerd",
  "customers.jobs.noPro": "Geen pro gekozen",
  "customers.jobs.deletedParty": "Account verwijderd",
  "customers.jobs.none": "Geen aanvragen voor dit account.",
  "customers.jobs.foot": "Hoogstens de laatste {count} aanvragen, als klant of als pro.",

  "customers.journal.recorded": "Uw raadpleging van dit logboek wordt zelf ook vastgelegd.",
  "customers.journal.locked": "Het auditlogboek vereist",
  "customers.lockedRoles": "Uw rollen ({roles}) bevatten dit niet.",
  "customers.journal.onBehalf": "namens {id}",
  "customers.journal.actorWithRoles": "{name} ({roles})",
  "customers.journal.reason": "reden: {reason}",
  "customers.journal.empty": "Voor dit account is nog niets vastgelegd.",
  "customers.journal.all": "Openen in het auditlogboek →",
  "customers.journal.denied": "geweigerd",
  "customers.journal.succeeded": "gelukt",

  // ── Choose my password (public) ──
  "setPassword.title": "Mijn wachtwoord kiezen",
  "setPassword.subtitle": "Gebruik de 6-cijferige code die u per sms bij uw uitnodiging hebt ontvangen.",
  "setPassword.email": "Zakelijk e-mailadres",
  "setPassword.code": "Code uit de sms",
  "setPassword.password": "Nieuw wachtwoord",
  "setPassword.confirm": "Bevestig het wachtwoord",
  "setPassword.rules": "Het wachtwoord moet:",
  "setPassword.rule.length": "minstens {min} tekens lang zijn",
  "setPassword.rule.tooLong": "hoogstens {max} tekens lang zijn",
  "setPassword.rule.mix": "een letter bevatten en een teken dat geen letter is",
  "setPassword.rule.email": "uw e-mailadres niet bevatten ({name})",
  "setPassword.rule.emailGeneric": "uw e-mailadres niet bevatten",
  "setPassword.mismatch": "De twee wachtwoorden zijn niet gelijk.",
  "setPassword.codeFormat": "De code bestaat uit 6 cijfers.",
  "setPassword.emailFormat": "Voer een geldig e-mailadres in.",
  "setPassword.submit": "Mijn wachtwoord opslaan",
  "setPassword.submitting": "Opslaan…",
  "setPassword.back": "Terug naar aanmelden",
  "setPassword.done": "Wachtwoord opgeslagen. Meld u aan met uw e-mailadres en dit wachtwoord.",
  "signIn.setPassword": "Uitgenodigd? Mijn wachtwoord kiezen",
  "signIn.or": "of",
  "signIn.heading": "Walliyo-console",
  "signIn.forgot": "Wachtwoord vergeten?",
  "signIn.environment": "Omgeving",
  "signIn.build": "Build",
  "signIn.googleUnavailable":
    "Inloggen met Google is niet beschikbaar. Gebruik uw e-mailadres en wachtwoord, of waarschuw de eigenaar.",
  "error.setPassword.invalid_code":
    "Dit e-mailadres en deze code horen bij geen enkele openstaande uitnodiging. Controleer beide; is de code kwijt of verlopen, vraag dan om een nieuwe uitnodiging.",
  "error.setPassword.too_many_attempts":
    "Te veel onjuiste codes: deze code is niet meer geldig. Vraag om een nieuwe uitnodiging.",
  "error.setPassword.validation_error":
    "Het wachtwoord voldoet niet aan de regels, of de code heeft niet het juiste formaat. Corrigeer en probeer het opnieuw.",

  // ── Dossiers (the support case queue) ──
  "cases.newCall": "+ Gesprek vastleggen",
  "cases.queue.aria": "Dossierwachtrij",
  "cases.queue.views": "Weergaven van de wachtrij",
  "cases.view.all": "Alle",
  "cases.view.unassigned": "Niet toegewezen",
  "cases.view.mine": "Van mij",
  "cases.view.late": "Te laat",
  "cases.filter.status": "Status",
  "cases.filter.notClosed": "Alle behalve gesloten",
  "cases.filter.channel": "Kanaal",
  "cases.filter.anyChannel": "Alle kanalen",
  "cases.filter.customer": "Klant {id}",
  "cases.filter.clear": "Klantfilter verwijderen",
  "cases.col.case": "Dossier",
  "cases.col.deadline": "Termijn",
  "cases.queue.loading": "Wachtrij laden…",
  "cases.queue.loadFailed": "De wachtrij kon niet worden geladen.",
  "cases.queue.empty": "Geen dossier past bij deze filters.",
  "cases.loadMore": "Meer laden",
  "cases.loadingMore": "Laden…",
  "cases.retry": "Opnieuw proberen",
  "cases.pick": "Kies een dossier in de wachtrij om de tijdlijn te zien.",
  "cases.loading": "Dossier laden…",
  "cases.loadFailed": "Dit dossier kon niet worden geladen.",
  "cases.notFound": "Geen dossier heeft deze ID. Misschien is die verkeerd gekopieerd.",
  "cases.refreshFailed": "Het dossier kon niet worden vernieuwd: wat u ziet, is misschien verouderd.",
  "cases.deadline.late": "Te laat · {time}",
  "cases.deadline.left": "nog {time}",
  "cases.deadline.replied": "Beantwoord",
  "cases.deadline.closed": "Gesloten",
  "cases.channel.phone": "Gesprek",
  "cases.channel.email": "E-mail",
  "cases.channel.chat": "Chat in de app",
  "cases.status.open": "Open",
  "cases.status.waiting_on_customer": "Wacht op klant",
  "cases.status.closed": "Gesloten",
  "access.mine.title": "Wat u heeft aangevraagd",
  "access.mine.none": "U heeft niets aangevraagd.",
  "access.mine.what": "Wat",
  "access.mine.state": "Hoe ver het is",
  "access.mine.asked": "Aangevraagd",
  "access.mine.withWhom": "Bij",
  "access.mine.waiting": "Wacht",
  "access.mine.granted": "Verleend",
  "access.mine.refused": "Geweigerd",
  "access.mine.overdue": "Te laat",
  "access.mine.nobody": "Nog niemand",
  "access.mine.answer": "Antwoord",
  "access.mine.loading": "Uw verzoeken laden…",
  "access.mine.loadFailed": "Uw verzoeken konden niet worden gelezen.",
  "access.ask.title": "Meer aanvragen",
  "access.ask.explain":
    "Iets bouwen is geen reden om de gegevens erin te hebben. Vraag om het kleinste dat u laat afmaken, zolang u het nodig heeft. Het gaat naar iemand die het kan verlenen, wordt alleen aan u verleend en eindigt vanzelf.",
  "access.ask.what": "Wat u nodig heeft",
  "access.ask.until": "Tot",
  "access.ask.why": "Waarom u het nodig heeft",
  "access.ask.whyHint": "Wat u doet, en waarom dit het kleinste is dat het mogelijk maakt",
  "access.ask.send": "Verzoek versturen",
  "access.ask.pickOne": "Kies wat u nodig heeft",
  "access.ask.pastDate": "Noem een datum in de toekomst, of laat het open.",
  "access.ask.sent": "Verstuurd. Het is zaak {reference}.",
  "cases.kind.access": "Toegangsverzoek",
  "cases.kind.customer": "Klant",
  "cases.kind": "Soort",
  "cases.access.wants": "Vraagt om",
  "cases.access.until": "Tot",
  "cases.access.grant": "Verlenen",
  "cases.access.refuse": "Weigeren",
  "cases.access.own": "U kunt uw eigen verzoek niet beantwoorden.",
  "cases.access.explain":
    "Alleen aan deze persoon verleend, nooit aan het team. Het eindigt op de gevraagde datum, en iedereen met de bevoegdheid kan het eerder beëindigen.",
  "cases.priority": "Prioriteit: {priority}",
  "cases.priority.low": "Laag",
  "cases.priority.normal": "Normaal",
  "cases.priority.high": "Hoog",
  "cases.priority.urgent": "Dringend",
  "cases.unknownCaller": "Onbekende beller",
  "cases.unknownCallerPhone": "Onbekende beller · {phone}",
  "cases.customerWithPhone": "{name} · {phone}",
  "cases.ownedBy": "toegewezen aan {name}",
  "cases.unassigned": "niet toegewezen",
  "cases.closedBecause": "Gesloten · reden: {reason}",
  "cases.timeline.aria": "Tijdlijn van het dossier",
  "cases.timeline.empty": "Er is nog niets vastgelegd in dit dossier.",
  "cases.internal": "Intern",
  "cases.entry.call": "Gesprek",
  "cases.entry.callWithDuration": "Gesprek ({duration})",
  "cases.entry.note": "Interne notitie",
  "cases.entry.chatIn": "Bericht van de klant in de app",
  "cases.entry.chatOut": "Antwoord in de app",
  "cases.entry.smsIn": "Sms van de klant",
  "cases.entry.smsOut": "Antwoord via sms",
  "cases.entry.smsOutTo": "Sms naar {phone}",
  "cases.entry.emailIn": "E-mail van de klant",
  "cases.entry.emailOut": "Antwoord via e-mail",
  "cases.sms.pending": "Wordt verzonden",
  "cases.sms.sent": "Verzonden",
  "cases.sms.failed": "Niet verzonden",
  "cases.action.claim": "Oppakken",
  "cases.action.reassign": "Opnieuw toewijzen",
  "cases.action.link": "Aan een klant koppelen",
  "cases.action.relink": "Andere klant",
  "cases.action.close": "Sluiten",
  "cases.needs": "Vereist {feature}",
  "cases.sending": "Verzenden…",
  "cases.cancel": "Annuleren",
  "cases.reload": "Dossier opnieuw laden",
  "cases.reason": "Reden",
  "cases.reasonHint": "Wordt met uw naam in het auditlogboek vastgelegd.",
  "cases.stale":
    "Dit dossier is gewijzigd terwijl u ernaar keek. Laad het opnieuw, bekijk wat er veranderd is en probeer het dan opnieuw: uw tekst blijft bewaard.",
  "cases.claim.done": "{reference} is nu van u.",
  "cases.claim.taken": "Te laat: {name} heeft dit dossier net opgepakt. Kies een ander.",
  "cases.composer.aria": "Schrijven in het dossier",
  "cases.composer.reply": "Antwoorden",
  "cases.composer.note": "Interne notitie",
  "cases.composer.call": "Gesprek vastleggen",
  "cases.reply.noChannel": "Geen klantaccount gekoppeld: koppel de klant om in de app te antwoorden, of bel hem terug.",
  "cases.reply.notified": "De klant krijgt een melding in de app. Nooit een sms.",
  "cases.reply.label": "Antwoord aan {name}",
  "cases.reply.sendChat": "Versturen in de app",
  "cases.reply.doneChat": "Antwoord verstuurd in de app.",
  "cases.reply.closed": "Dit dossier is gesloten: er wordt niet meer op geantwoord.",
  "cases.reply.unassigned": "Pak dit dossier op om de klant te antwoorden.",
  "cases.reply.notOwner":
    "Alleen de eigenaar van het dossier antwoordt de klant. Vraag zo nodig om het opnieuw toe te wijzen.",
  "cases.refused.claimed": "Te laat: iemand anders heeft dit dossier net genomen. Kies een ander.",
  "cases.refused.closed": "Dit dossier is intussen gesloten. Laad het opnieuw.",
  "cases.refused.notOwner":
    "Dit dossier is nu van iemand anders. Laad het opnieuw, of vraag om het opnieuw toe te wijzen.",
  "cases.refused.noCustomer":
    "Geen klantaccount gekoppeld: koppel de klant om in de app te antwoorden, of bel hem terug.",
  "cases.note.hint": "Alleen zichtbaar voor het team, nooit voor de klant.",
  "cases.note.label": "Interne notitie",
  "cases.note.submit": "Notitie toevoegen",
  "cases.note.done": "Interne notitie toegevoegd.",
  "cases.call.label": "Wat er gezegd is (interne samenvatting)",
  "cases.call.minutes": "Duur (minuten)",
  "cases.call.submit": "Gesprek vastleggen",
  "cases.call.done": "Gesprek vastgelegd.",
  "cases.reassign.title": "{reference} opnieuw toewijzen",
  "cases.reassign.from": "Nu toegewezen aan {name}.",
  "cases.reassign.unassigned": "Dit dossier is nog aan niemand toegewezen.",
  "cases.reassign.to": "Nieuwe eigenaar",
  "cases.reassign.choose": "Kies een teamlid",
  "cases.reassign.loading": "Team laden…",
  "cases.reassign.toId": "ID van het teamlid",
  "cases.reassign.idHint": "Zonder toegang tot de teamlijst plakt u de ID van het teamlid.",
  "cases.reassign.submit": "Opnieuw toewijzen",
  "cases.reassign.done": "Dossier toegewezen aan {name}.",
  "cases.close.title": "{reference} sluiten",
  "cases.close.body": "De klant kan er niet meer op antwoorden; komt hij terug, dan wordt een nieuw dossier geopend.",
  "cases.close.submit": "Dossier sluiten",
  "cases.close.done": "{reference} is gesloten.",
  "cases.link.title": "{reference} aan een klant koppelen",
  "cases.link.body": "Zoek het account van de klant die contact opnam met support.",
  "cases.link.caller": "De beller gaf {phone} op. Zoek zijn account.",
  "cases.link.current": "Nu gekoppeld aan {name}.",
  "cases.link.submit": "Koppelen",
  "cases.link.done": "Dossier gekoppeld aan {name}.",
  "cases.customer.search": "Klant zoeken",
  "cases.customer.placeholder": "Naam, telefoon, e-mail of ID",
  "cases.customer.searchButton": "Zoeken",
  "cases.customer.searching": "Zoeken…",
  "cases.customer.none": "Geen account gevonden.",
  "cases.customer.results": "Gevonden accounts",
  "cases.customer.id": "ID van het klantaccount",
  "cases.customer.idHint": "Zoeken vereist {feature}: plak de account-ID.",
  "cases.newCall.title": "Gesprek vastleggen",
  "cases.newCall.who": "Wie belde er?",
  "cases.newCall.known": "Een klant",
  "cases.newCall.unknown": "Een onbekende beller",
  "cases.newCall.phone": "Nummer van de beller",
  "cases.newCall.phoneHint": "In internationaal formaat, bijvoorbeeld +224 621 23 45 67.",
  "cases.newCall.subject": "Onderwerp",
  "cases.newCall.internal": "Intern: de klant ziet deze samenvatting nooit.",
  "cases.newCall.priority": "Prioriteit",
  "cases.newCall.submit": "Dossier openen",
  "cases.problem.reason": "Zeg in een paar woorden waarom.",
  "cases.problem.body": "Schrijf iets.",
  "cases.problem.tooLong": "Te lang: hoogstens {max} tekens.",
  "cases.problem.minutes": "De duur is een heel aantal minuten, van 0 tot {max}.",
  "cases.problem.phone": "Het nummer moet in internationaal formaat zijn, bijvoorbeeld +224621234567.",
  "cases.problem.pickCustomer": "Kies de klant.",
  "cases.problem.customerId": "Deze account-ID heeft niet het juiste formaat.",
  "cases.problem.pickStaff": "Kies wie het dossier krijgt.",
  "cases.problem.staffId": "Deze teamlid-ID heeft niet het juiste formaat.",
  "cases.problem.subject": "Geef het dossier een kort onderwerp.",
  // ── Verificaties ──
  "verifications.summary.open": "{count} wachtend · de oudste sinds {age}",
  "verifications.summary.none": "Geen verificatie wacht",
  "verifications.summary.shown": "{count} verificaties getoond",
  "verifications.filter.status": "Stand",
  "verifications.filter.status.open": "Alle wachtende",
  "verifications.filter.status.submitted": "Te beoordelen",
  "verifications.filter.status.flagged": "Verboden document",
  "verifications.filter.status.approved": "Goedgekeurd",
  "verifications.filter.status.rejected": "Afgewezen",
  "verifications.filter.document": "Soort document",
  "verifications.filter.document.all": "Alle",
  "verifications.filter.document.national_id": "Identiteitskaart",
  "verifications.filter.document.passport": "Paspoort",
  "verifications.queue.aria": "Wachtrij van verificaties, oudste eerst",
  "verifications.queue.loading": "Wachtrij laden…",
  "verifications.queue.loadFailed": "De wachtrij kon niet worden geladen.",
  "verifications.queue.emptyOpen": "Er wacht geen verificatie: de wachtrij is leeg.",
  "verifications.queue.empty": "Geen verificatie past bij deze filters.",
  "verifications.queue.waited": "Wachttijd sinds het insturen",
  "verifications.queue.end": "Einde van de wachtrij.",
  "verifications.flag.banned": "Verboden document",
  "verifications.status.submitted": "Te beoordelen",
  "verifications.status.flagged": "Verboden document",
  "verifications.status.approved": "Goedgekeurd",
  "verifications.status.rejected": "Afgewezen",
  "verifications.document.national_id": "Identiteitskaart",
  "verifications.document.passport": "Paspoort",
  "verifications.side.front": "Voorkant",
  "verifications.side.back": "Achterkant",
  "verifications.side.selfie": "Selfiefoto",
  "verifications.detail.pick": "Kies een verificatie in de wachtrij om die te beoordelen.",
  "verifications.detail.loading": "Verificatie laden…",
  "verifications.detail.loadFailed": "Deze verificatie kon niet worden geladen.",
  "verifications.detail.notFound": "Geen verificatie heeft deze id. Laad de wachtrij opnieuw.",
  "verifications.detail.noPhone": "zonder telefoon",
  "verifications.detail.submitted": "ingestuurd op {date}",
  "verifications.detail.versionTitle": "Beoordeelde versie: een besluit geldt alleen voor deze versie",
  "verifications.banned.title": "Verboden document",
  "verifications.banned.body":
    "Dit nummer hoort bij een document dat op {date} verboden is · reden: {reason}. Het kan nooit worden goedgekeurd: wijs de verificatie af.",
  "verifications.banned.bodyNoReason":
    "Dit nummer hoort bij een verboden document. Het kan nooit worden goedgekeurd: wijs de verificatie af.",
  "verifications.banned.notTold": "De pro hoort niet dat zijn document verboden is.",
  "verifications.images.aria": "Identiteitsdocumenten",
  "verifications.images.show": "Documenten tonen",
  "verifications.images.showAgain": "Opnieuw tonen",
  "verifications.images.loading": "Laden…",
  "verifications.images.notice":
    "Elke weergave wordt op uw naam vastgelegd in het auditlogboek en staat in de geschiedenis van de pro. De links verlopen na 2 minuten.",
  "verifications.images.recorded": "Weergave vastgelegd in het auditlogboek · links geldig tot {time}",
  "verifications.images.hide": "Verbergen",
  "verifications.images.expired":
    "De links zijn verlopen en de afbeeldingen zijn van het scherm gehaald. Opnieuw tonen wordt ook vastgelegd.",
  "verifications.images.locked": "Identiteitsafbeeldingen vereisen",
  "verifications.images.deleted": "De afbeeldingen zijn op {date} verwijderd, zoals de bewaarregel voorschrijft.",
  "verifications.col.field": "Veld",
  "verifications.col.read": "Gelezen op het document",
  "verifications.col.typed": "Ingevoerd door de pro",
  "verifications.col.match": "Overeenkomst",
  "verifications.field.name": "Naam",
  "verifications.field.dateOfBirth": "Geboren op",
  "verifications.field.expiresOn": "Verloopt op",
  "verifications.field.documentNumber": "Documentnummer",
  "verifications.notAsked": "niet gevraagd",
  "verifications.match.check": "Controleren op de afbeelding",
  "verifications.match.same": "Komt overeen",
  "verifications.match.different": "Komt niet overeen",
  "verifications.match.readOnly": "Alleen gelezen",
  "verifications.match.expired": "Verlopen",
  "verifications.match.valid": "Geldig",
  "verifications.match.banned": "Verboden",
  "verifications.match.notBanned": "Niet verboden",
  "verifications.last4Hint":
    "Alleen de laatste 4 tekens van het nummer worden bewaard ({last4}): vergelijk ze met de afbeelding.",
  "verifications.standing.title": "Account van de pro vandaag",
  "verifications.standing.verificationStatus": "Verificatiestand",
  "verifications.standing.approvalStatus": "Goedkeuring van het profiel",
  "verifications.standing.isVerified": "Badge ‘geverifieerd’",
  "verifications.standing.status.unverified": "Niet geverifieerd",
  "verifications.standing.status.pending": "In beoordeling",
  "verifications.standing.status.verified": "Geverifieerd",
  "verifications.standing.status.rejected": "Afgewezen",
  "verifications.standing.approval.pending": "Goed te keuren",
  "verifications.standing.approval.approved": "Goedgekeurd",
  "verifications.standing.approval.rejected": "Niet goedgekeurd",
  "verifications.yes": "Ja",
  "verifications.no": "Nee",
  "verifications.previous.title": "Eerdere inzendingen",
  "verifications.previous.none": "Eerste inzending van deze pro.",
  "verifications.approve.button": "Pro goedkeuren",
  "verifications.reject.button": "Afwijzen",
  "verifications.decided": "Over deze verificatie is al besloten.",
  "verifications.approve.banned":
    "Goedkeuren kan niet: het nummer hoort bij een verboden document. Wijs de verificatie af.",
  "verifications.approve.locked":
    "Goedkeuren vereist ook APPROVE_PROS_STAFF_FEATURE_ENABLEMENT, en die zit niet in uw rollen.",
  "verifications.decided.approved": "Goedgekeurd door {name} op {date}.",
  "verifications.decided.rejected": "Afgewezen door {name} op {date}.",
  "verifications.decided.reasonCode": "Reden: {reason}",
  "verifications.decided.reason": "Notitie van het team: ‘{reason}’",
  "verifications.outcome.approved":
    "{name} is goedgekeurd: het profiel is geverifieerd en kan worden gevonden en ingehuurd.",
  "verifications.outcome.rejected": "Verificatie geweigerd. De pro krijgt een melding in de app, in zijn taal.",
  "verifications.approve.title": "{name} goedkeuren",
  "verifications.approve.body":
    "Het document wordt geaccepteerd en de pro wordt geverifieerd: hij kan worden gevonden en ingehuurd. Het besluit wordt met uw reden vastgelegd in het auditlogboek.",
  "verifications.approve.reason": "Reden (vastgelegd in het auditlogboek)",
  "verifications.approve.hint": "Bijv. ‘Kaart leesbaar, selfie klopt’.",
  "verifications.approve.submit": "Pro goedkeuren",
  "verifications.approve.tooShort": "Geef een reden van minstens {min} tekens.",
  "verifications.reject.title": "Verificatie van {name} afwijzen",
  "verifications.reject.body": "De pro kan in de app een nieuw document insturen.",
  "verifications.reject.preset": "Reden van weigering",
  "verifications.reject.presetNone": "Kies een reden…",
  "verifications.reject.code.photo_unreadable": "Foto onleesbaar",
  "verifications.reject.code.selfie_mismatch": "Selfie komt niet overeen",
  "verifications.reject.code.document_expired": "Document verlopen",
  "verifications.reject.code.document_not_accepted": "Document niet aanvaard",
  "verifications.reject.code.other": "Andere",
  "verifications.reject.reason": "Notitie voor het team (optioneel)",
  "verifications.reject.noteHint":
    "Nooit getoond aan de pro: die krijgt in de app het bericht bij de gekozen reden, in zijn taal.",
  "verifications.reject.submit": "Verificatie weigeren",
  "verifications.reject.pickCode": "Kies de reden van weigering.",
  "verifications.reason.tooLong": "De reden mag hoogstens {max} tekens hebben.",
  "verifications.reason.count": "{count} van {max} tekens",
  "verifications.dialog.version": "Besluit over versie {version}",
  "verifications.dialog.cancel": "Annuleren",
  "verifications.dialog.sending": "Versturen…",
  "verifications.error.stale":
    "Deze verificatie is gewijzigd terwijl u ernaar keek (misschien heeft iemand anders al besloten). Laad opnieuw om de huidige versie te zien en besluit dan opnieuw.",
  "verifications.error.approveRefused":
    "Goedkeuring geweigerd: uw rollen bevatten REVIEW_VERIFICATIONS en APPROVE_PROS niet, of het document is net verboden. Laad opnieuw.",
  "verifications.error.rejectRefused":
    "Afwijzen kan niet: uw rollen bevatten REVIEW_VERIFICATIONS niet meer. Vraag een verantwoordelijke om toegang.",
  "verifications.error.imagesRefused":
    "Afbeeldingen geweigerd: uw rollen bevatten VIEW_ID_IMAGES niet meer. Deze poging is vastgelegd in het auditlogboek.",
  "verifications.error.approveInvalid":
    "Goedkeuring geweigerd: over de verificatie is al besloten, het document is verboden of de reden is ongeldig. Laad opnieuw en controleer.",
  "verifications.error.rejectInvalid":
    "Weigering afgewezen: de verificatie is al beslist, of de notitie is langer dan {max} tekens.",
  "verifications.error.imagesDeleted":
    "De afbeeldingen zijn niet meer beschikbaar: ze zijn volgens de bewaarregel verwijderd, of de verificatie is niet gevonden.",
  "verifications.error.outcomeUnknown":
    "Geen antwoord van de server: het besluit is misschien opgeslagen. Probeer het opnieuw: dezelfde klik kan niet twee keer worden uitgevoerd.",
};
